(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode(`.cvg-error_NZK0e{align-items:center;color:#c44a4a;display:flex;flex:1;flex-direction:column;justify-content:center}.cvg-loader_lPaby{--loader-fill-color: #555;--loader-font-color: #777;--loader-font-size: .75rem;--loader-max-width: 100px;align-items:center;display:flex;flex:1;flex-direction:column;justify-content:center}.cvg-loader_lPaby>svg{fill:var(--loader-fill-color);max-width:var(--loader-max-width)}.cvg-loader_lPaby>i{color:var(--loader-font-color);font-size:var(--loader-font-size);margin:-12px 0 0}.cvg-dialog_dwQHc{--dialog-backdrop-color: rgba(0, 0, 0, .75);--dialog-border: none;--dialog-border-radius: 5px;--dialog-max-height: min(1000px, 85vh);--dialog-max-width: min(1000px, 85vw);--dialog-padding: 0;--loader-overlay-fill-color: #555;--loader-overlay-font-color: #777;--loader-overlay-font-size: .75rem;--loader-overlay-max-width: 100px}.cvg-dialog_dwQHc{border:var(--dialog-border, none);border-radius:var(--dialog-border-radius, 5px);max-height:var(--dialog-max-height, 85vh);max-width:var(--dialog-max-width, 85vw);padding:var(--dialog-padding, 0)}.cvg-dialog_dwQHc::backdrop{background:var(--dialog-backdrop-color, rgba(0, 0, 0, .75))}.cvg-dialog_dwQHc:not([open]){display:none}.cvg-dialog_dwQHc .cvg-loader_qGkDk{background:#ffffffe6;display:flex;top:0;right:0;bottom:0;left:0;position:absolute}.cvg-dialog_dwQHc .cvg-loader_qGkDk>div[class*=cvg-loader]{--loader-fill-color: var(--loader-overlay-fill-color, #555);--loader-font-color: var(--loader-overlay-font-color, #777);--loader-font-size: var(--loader-overlay-font-size, .75rem);--loader-max-width: var(--loader-overlay-max-width, 100px)}.cvg-menu-button_Xuz1t{background-color:transparent;cursor:pointer}.cvg-menu-items_skK-W{display:flex;flex-direction:column;overflow:hidden;position:absolute;top:100%;transform:scaleY(1);transform-origin:top;transition:transform .2s}.cvg-menu-items_skK-W[data-show=false]{transform:scaleY(0);transition:none}.cvg-menu-items_skK-W[data-align=right i]{right:0}.cvg-menu-items_skK-W[data-align=left i]{left:0}.cvg-menu-items_skK-W[data-align=full i]{left:0;right:0}.cvg-menu_Fl7DU{-webkit-user-select:auto;user-select:auto}.cvg-tooltip_Ut22K{--tooltip-bg-color: #005eb8;--tooltip-font-color: #fff;--tooltip-icon-color: #005eb8;--tooltip-icon-height: 18px;position:relative}.cvg-tooltip_Ut22K [aria-describedby]{align-items:center;cursor:pointer;display:flex;justify-content:center}.cvg-tooltip_Ut22K [aria-describedby]:hover+p,.cvg-tooltip_Ut22K [aria-describedby]:focus+p{opacity:1;visibility:visible}.cvg-tooltip_Ut22K svg{height:var(--tooltip-icon-height, 18px);fill:var(--tooltip-icon-color, #005eb8)}.cvg-tooltip_Ut22K>p{background-color:var(--tooltip-bg-color, #005eb8);border-radius:5px;box-shadow:0 0 8px #00000080;color:var(--tooltip-font-color, #fff);font-size:.875rem;line-height:1.2;opacity:0;padding:12px;position:absolute;bottom:30px;max-width:max-content;transition:all .5s;visibility:hidden;white-space:normal;width:var(--width)}.cvg-tooltip_Ut22K>p[data-align=left]{left:-15px}.cvg-tooltip_Ut22K>p[data-align=right]{right:-15px}.cvg-tooltip_Ut22K>p:after{border:solid 10px;border-color:var(--tooltip-bg-color, #005eb8) transparent transparent;bottom:-16px;content:"";position:absolute}.cvg-tooltip_Ut22K>p[data-align=left]:after{left:14px}.cvg-tooltip_Ut22K>p[data-align=right]:after{right:14px}.cvg-label_4caVP{align-items:center;display:flex;gap:8px;margin:var(--label-margin);width:100%}.cvg-label_4caVP>label{color:var(--label-color);font-size:var(--label-font-size)}.cvg-checkbox_AUQXd{align-items:center;display:flex;flex-direction:row-reverse;justify-content:flex-end}.cvg-checkbox_AUQXd div[class*=cvg-label]{--label-margin: 0 0 0 8px}.cvg-checkbox_AUQXd label{cursor:pointer}.cvg-checkbox_AUQXd>input{-moz-appearance:initial!important;appearance:initial!important;cursor:pointer;outline:none;-webkit-appearance:checkbox!important}.cvg-checkbox_AUQXd>input:focus{box-shadow:1px 1px 4px .5px var(--input-focus-border-color)}div[data-error]>.cvg-checkbox_AUQXd{border-radius:4px;padding:6px}.cvg-currency_laIPT{display:flex}.cvg-currency_laIPT>i{font-style:normal;padding-right:calc(var(--input-padding) / 2)}.cvg-currency_laIPT>input{background-color:var(--input-background-color);color:var(--input-color);font-size:var(--input-font-size);font-weight:var(--input-font-weight);padding:0;width:100%}[data-error] .cvg-currency_laIPT[data-show-state*=error]>*{background-color:var(--error-background-color)}.cvg-characterCount_JM6Ud{--counter-color: #727272;--counter-font-size: .75rem;--counter-font-weight: 400;color:var(--counter-color);font-size:var(--counter-font-size);font-weight:var(--counter-font-weight);margin:0 -6px -6px 0;line-height:1;text-align:right}.cvg-characterCount_JM6Ud[data-warn=true]{color:var(--error-color)}.cvg-flex-textarea_oijZP{position:relative}.cvg-flex-textarea_oijZP>[data-size-setter]{opacity:0;overflow-wrap:break-word;visibility:hidden;white-space:pre-wrap}.cvg-flex-textarea_oijZP>textarea{background-color:transparent;color:var(--input-color);font-size:var(--input-font-size);font-weight:var(--input-font-weight);top:0;right:0;bottom:0;left:0;padding:var(--input-padding);position:absolute;height:100%;width:100%}.cvg-toggle_dM8Pm{flex:1 1 100%;margin-top:12px}.cvg-toggle_dM8Pm>button{align-items:center;align-self:flex-start;background-color:transparent;color:var(--input-color, #606060);cursor:pointer;display:flex;font-size:var(--input-font-size, .875rem);gap:4px}.cvg-toggle_dM8Pm>button>svg{fill:var(--selected-color, #777);height:20px;width:20px}.cvg-toggle_dM8Pm>button:hover>svg{filter:brightness(.675)}div[data-type=multiselect]{--add-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z'/%3E%3C/svg%3E");--minus-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z'/%3E%3C/svg%3E");--selected-font-color: #fff;--input-border-radius: 20px;--input-font-size: .875rem;--input-padding: 4px 4px 4px 12px;--input-width: auto}div[data-type=multiselect]>div[data-show-all]{display:grid;grid-template-rows:0fr;opacity:0;transition:grid-template-rows .15s,opacity .1s .05s}div[data-type=multiselect]>div[data-show-all=true]{grid-template-rows:1fr;opacity:1}.cvg-multiSelect_MH-Ql{display:flex;flex-wrap:wrap;gap:12px;overflow:hidden;margin:0 0 0 -2px;padding:2px}.cvg-multiSelect_MH-Ql>button{align-items:center;cursor:pointer;display:flex;line-height:1}.cvg-multiSelect_MH-Ql>button:not([data-toggle]):after{content:var(--add-icon);flex:0 0 20px;margin-left:8px;height:20px;width:20px}.cvg-multiSelect_MH-Ql>button[data-selected=true]{background-color:var(--selected-background-color);color:var(--selected-font-color)}.cvg-multiSelect_MH-Ql>button[data-selected=true]:after{content:var(--minus-icon)}div[data-error]>.cvg-multiSelect_MH-Ql{border-radius:5px;padding:12px}.cvg-password_Xaio8{display:flex}.cvg-password_Xaio8>input{background-color:var(--input-background-color);color:var(--input-color);font-size:var(--input-font-size);font-weight:var(--input-font-weight);padding:0;width:100%}.cvg-password_Xaio8>button{background:no-repeat center/50% url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23777' d='M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'/%3E%3C/svg%3E") transparent;margin:-8px;outline:none;padding:0 24px;cursor:pointer}.cvg-password_Xaio8>input[type=text]+button{background:no-repeat center/50% url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23777' d='M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z'/%3E%3C/svg%3E") transparent}[data-error] .cvg-password_Xaio8[data-show-state*=error]>*{background-color:var(--error-background-color)}.cvg-pin-code_dPUUl{display:flex;gap:var(--input-gap)}.cvg-pin-code_dPUUl>input[data-mode]{padding:var(--input-padding);text-align:center;transition:box-shadow .2s,transform .2s}.cvg-pin-code_dPUUl>input:disabled{color:#ccc}.cvg-pin-code_dPUUl>input[data-mode=box]{box-shadow:0 0 0 var(--input-border-width) var(--input-border-color)}.cvg-pin-code_dPUUl>input[data-mode=box]:focus{--input-border-width: 2px;transform:scale(1.2)}.cvg-pin-code_dPUUl>input[data-mode=box]:disabled{background-color:#eee}.cvg-pin-code_dPUUl>input[data-mode=underline]{--error-background-color: transparent;--input-border-radius: 0;--input-hover: none;box-shadow:0 var(--input-border-width) 0 0 var(--input-border-color)}.cvg-pin-code_dPUUl>input[data-mode=underline]:focus-within{box-shadow:0 var(--input-focus-border-width) 0 0 var(--input-focus-border-color)}div[data-error] .cvg-pin-code_dPUUl>input[data-mode=underline]{box-shadow:0 var(--input-error-border-width) 0 0 var(--input-error-border-color)}div[data-error] .cvg-pin-code_dPUUl>input[data-mode=underline]:focus-within{box-shadow:0 var(--input-focus-border-width) 0 0 var(--input-error-border-color)}.cvg-radio_k1aRx li{align-items:center;display:flex;flex-direction:row-reverse;justify-content:flex-end}.cvg-radio_k1aRx li div[class*=cvg-label]{--label-margin: 0 0 0 8px}.cvg-radio_k1aRx li label{cursor:pointer}.cvg-radio_k1aRx li input[type=radio]{-moz-appearance:radio!important;appearance:radio!important;cursor:pointer;outline:none;-webkit-appearance:radio!important}.cvg-radio_k1aRx li input[type=radio]:focus-visible{filter:drop-shadow(2px 2px 1px rgba(0,0,0,.75))}div[data-error]>.cvg-radio_k1aRx{border-radius:4px;padding:6px}.cvg-select_ETuEj{position:relative}.cvg-select_ETuEj:has(select:not([multiple])):after{align-items:center;bottom:0;content:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -2 24 24' width='24px' fill='%23000000'%3E%3Cpath d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'/%3E%3C/svg%3E");display:flex;padding:0 4px;pointer-events:none;position:absolute;right:0;top:0}.cvg-select_ETuEj:has(select:not([multiple])):has(select[disabled]):after{content:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -2 24 24' width='24px' fill='%23ccc'%3E%3Cpath d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'/%3E%3C/svg%3E")}.cvg-select_ETuEj select{--input-padding: 10px 30px 10px 10px;cursor:pointer;min-width:max-content}.cvg-textarea_idFrv{--textarea-min-height: 100px;display:flex;flex:1;flex-direction:column;min-height:var(--textarea-min-height)}.cvg-textarea_idFrv>textarea{background-color:var(--input-background-color);color:var(--input-color);flex:1;font-size:var(--input-font-size);font-weight:var(--input-font-weight);padding:0;width:100%}.cvg-toggle_usN0s{--toggle-off-background-color: #ccc;--toggle-height: 16px;align-items:center;color:var(--label-color, #606060);display:inline-flex;font-size:var(--label-font-size, 1rem)}.cvg-toggle_usN0s>button{background-color:transparent;border-radius:var(--toggle-height, 16px);cursor:pointer}.cvg-toggle_usN0s>button:focus-visible{box-shadow:0 0 0 2px #606060;outline:none}.cvg-toggle_usN0s>button *{pointer-events:none}.cvg-toggle_usN0s>button>span{background:var(--toggle-off-background-color);border:max(4px,calc(var(--toggle-height) / 9)) solid var(--toggle-off-background-color);border-radius:calc(var(--toggle-height, 16px));box-sizing:content-box;display:flex;margin:2px;transition:.1s ease-in-out;height:var(--toggle-height, 16px);width:calc(var(--toggle-height, 16px) * 2)}.cvg-toggle_usN0s>button[value=true]>span{background:var(--selected-background-color);border:max(4px,calc(var(--toggle-height) / 9)) solid var(--selected-background-color)}.cvg-toggle_usN0s>button>span:before{background:#fff;border-radius:50%;content:"";transition:.1s ease-in-out;height:var(--toggle-height);width:var(--toggle-height)}.cvg-toggle_usN0s>button[value=true]>span:before{transform:translate(100%)}.cvg-toggle_usN0s>[class*=cvg-label]:not(:empty){margin:0 0 0 8px}.cvg-toggle_usN0s>[class*=cvg-label]:not(:empty)>label{cursor:pointer}.cvg-input_A-eRZ{--error-background-color: #fef6f6;--error-color: #c44a4a;--input-background-color: #fff;--input-border-color: #ccc;--input-border-width: 1px;--input-border-radius: 5px;--input-color: #606060;--input-font-size: 1rem;--input-font-weight: 300;--input-gap: 3%;--input-max-width: 100%;--input-padding: 10px;--input-width: 100%;--input-placeholder-color: #999;--input-placeholder-font-size: 1rem;--input-placeholder-font-style: italic;--input-error: 0 0 0 1px #c44a4a;--input-error-border-color: #c44a4a;--input-error-border-width: 1px;--input-focus-border-color: #777;--input-focus-border-width: 2px;--input-hover: drop-shadow(0 1px 3px rgba(0, 0, 0, .15));--label-color: #555;--label-font-size: 1rem;--label-margin: 0 0 4px;--selected-background-color: #656565}.cvg-input_A-eRZ [data-show-state*=default]{background-color:var(--input-background-color, #fef6f6);border-radius:var(--input-border-radius, 5px);box-shadow:0 0 0 var(--input-border-width, 1px) var(--input-border-color, #ccc);color:var(--input-color, #606060);font-size:var(--input-font-size, 1rem);font-weight:var(--input-font-weight, 300);max-width:var(--input-max-width, 100%);padding:var(--input-padding, 10px);width:var(--input-width, 100%)}.cvg-input_A-eRZ input,.cvg-input_A-eRZ textarea,.cvg-input_A-eRZ select,.cvg-input_A-eRZ button{-moz-appearance:none;appearance:none;outline:none;resize:none;-webkit-appearance:none}.cvg-input_A-eRZ [data-show-state*=hover]:hover{filter:var(--input-hover, drop-shadow(0 1px 3px rgba(0, 0, 0, .15)))}.cvg-input_A-eRZ [data-show-state*=focus]:focus-within{box-shadow:0 0 0 var(--input-focus-border-width, 2px) var(--input-focus-border-color, #777)}.cvg-input_A-eRZ[data-error] [data-show-state*=error]{background-color:var(--error-background-color, #fef6f6);box-shadow:0 0 0 var(--input-error-border-width, 1px) var(--input-error-border-color, #c44a4a)}.cvg-input_A-eRZ[data-error] [data-show-state*=focus]:focus-within{box-shadow:0 0 0 var(--input-focus-border-width, 2px) var(--input-error-border-color, #c44a4a)}.cvg-input_A-eRZ input::placeholder,.cvg-input_A-eRZ textarea::placeholder{color:var(--input-placeholder-color, #999);font-size:var(--input-placeholder-font-size, 1rem);font-style:var(--input-placeholder-font-style, italic)}.cvg-error_7JDBy:not(:empty){color:var(--error-color, #c44a4a);font-size:.875em;font-weight:400;margin:3px 0 0 2px}.cvg-input_A-eRZ[data-type=textarea]{display:flex;flex:1;flex-direction:column}.cvg-drop-down_lDkQ2{--button-background: center / 24px 24px no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFFFFF'%3E%3Cpath d='M0 0h24v24H0V0z' fill='none'/%3E%3Cpath d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z'/%3E%3C/svg%3E");--button-height: 44px;--button-width: 44px}.cvg-drop-down_lDkQ2>button{background:var(--button-background);height:var(--button-height);width:var(--button-width)}.cvg-modal_hvdh6{animation:cvg-fadein_z-BQq .25s;background:#323232f2;position:fixed;top:0;left:0;width:100%;height:100%;z-index:1000;display:flex;align-items:center;flex-direction:column;justify-content:center}.cvg-modal-content_CUFZ7{display:flex;flex-direction:column;align-items:center;justify-content:center;max-height:900px;max-width:900px;height:80%;width:80%}@keyframes cvg-fadein_z-BQq{0%{opacity:0}to{opacity:1}}.cvg-alert-modal_DcbS4{background-color:#fff;border-radius:12px;padding:24px;overflow:auto}.cvg-close_atiWa{margin-top:32px;text-align:right}.cvg-close_atiWa>button{background-color:#005eb8;border-radius:8px;color:#fff;cursor:pointer;font-weight:500;padding:10px 16px}.cvg-confirm-modal_1LRpL{background-color:#fff;border-radius:12px;padding:24px;overflow:auto}.cvg-actions_X5-2p{margin-top:32px;text-align:right}.cvg-actions_X5-2p>button{padding:10px 16px;border-radius:8px;font-weight:500;cursor:pointer}.cvg-actions_X5-2p>button.cvg-cancel_uZqiE{background-color:transparent;margin-right:16px}.cvg-confirm-modal_1LRpL[data-type=proceed] .cvg-actions_X5-2p>button.cvg-submit_cv4F9{background-color:#005eb8;color:#fff}.cvg-confirm-modal_1LRpL[data-type=warning] .cvg-actions_X5-2p>button.cvg-submit_cv4F9{background-color:#e34949;color:#fff}.cvg-content-modal_k-CEf{border-radius:8px;display:flex;flex-direction:column;max-height:100%}.cvg-title-bar_aLm3s{background-color:#eee;border-radius:10px 10px 0 0;display:flex;align-items:center;flex-shrink:0;justify-content:flex-end}.cvg-title-bar_aLm3s>h1{flex:1;padding:20px}.cvg-title-bar_aLm3s>button{background:no-repeat center / 60% url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-5 -5 50 50'%3E%3Cpath d='M 10,10 L 30,30 M 30,10 L 10,30' stroke='%23111' stroke-linecap='round' stroke-width='6'%3E%3C/path%3E%3C/svg%3E");cursor:pointer;height:50px;width:50px}.cvg-content_TYS4F{background-color:#fff;border-radius:0 0 10px 10px;height:100%;overflow-y:auto;padding:20px}.cvg-title-bar_aLm3s:not([data-title]){background-color:transparent;margin:0 -16px -8px 0;filter:brightness(100)}.cvg-title-bar_aLm3s:not([data-title])+.cvg-content_TYS4F{border-radius:10px}.cvg-photo-modal_uNvSV{display:flex;flex-direction:column;max-height:90%;position:relative}.cvg-photo-modal_uNvSV>img{box-shadow:0 15px 10px -12px #00000080;max-height:100%;min-height:0;object-fit:cover}.cvg-photo-modal_uNvSV>button{background:#000000b3 no-repeat center / 50% url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-5 -5 50 50'%3E%3Cpath d='M 10,10 L 30,30 M 30,10 L 10,30' stroke='%23fff' stroke-linecap='round' stroke-width='5'%3E%3C/path%3E%3C/svg%3E");border-radius:50%;position:absolute;right:12px;top:12px;height:44px;width:44px;cursor:pointer}.cvg-button_bhZ6t{cursor:pointer}.cvg-button_bhZ6t[data-photo-bg=true]{background:center/cover var(--photo-url)}.cvg-notification_rCsSL[data-type=error i]{--bgRGB: 200 45 45}.cvg-notification_rCsSL[data-type=info i]{--bgRGB: 98 145 160}.cvg-notification_rCsSL[data-type=success i]{--bgRGB: 115 170 30}.cvg-notification_rCsSL[data-type=warning i]{--bgRGB: 255 204 0}.cvg-notification-container_4sUVq{align-items:center;background-color:#fff;border-radius:5px;display:flex;inset:auto 0 20px;justify-content:center;margin:0 auto;max-width:800px;position:fixed;transform:translateY(100vh);width:85%}.cvg-notification_rCsSL{align-items:center;background:rgb(var(--bgRGB) / .1);border:solid 2px rgb(var(--bgRGB));border-radius:5px;box-shadow:0 0 12px 4px #00000040;display:flex;gap:16px;padding:12px;width:100%}.cvg-notification_rCsSL svg{background:rgb(var(--bgRGB));cursor:pointer;fill:#fff;margin:0 12px 0 24px;height:24px;width:24px}.cvg-notification_rCsSL[data-type]:before{background-color:rgb(var(--bgRGB));border-radius:50%;padding:6px;height:24px;width:24px}.cvg-notification_rCsSL[data-type=error i]:before{content:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fff'%3E%3Ccircle cx='12' cy='19' r='2'/%3E%3Cpath d='M10 3h4v12h-4z'/%3E%3C/svg%3E")}.cvg-notification_rCsSL[data-type=info i]:before{align-items:center;content:"i";color:#fff;display:flex;font-size:1.25rem;font-weight:600;justify-content:center}.cvg-notification_rCsSL[data-type=success i]:before{content:url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' stroke='%23fff' stroke-width='2' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' /%3E%3C/svg%3E")}.cvg-notification_rCsSL[data-type=warning i]:before{content:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'/%3E%3C/svg%3E")}.cvg-notification_rCsSL span{flex:1;font-size:clamp(.75rem,5vw,1rem);font-weight:300;line-height:1}.cvg-notification_rCsSL button{background:none;border:none;content:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='48' width='48' fill='%23333'%3E%3Cpath d='m12.45 37.65-2.1-2.1L21.9 24 10.35 12.45l2.1-2.1L24 21.9l11.55-11.55 2.1 2.1L26.1 24l11.55 11.55-2.1 2.1L24 26.1Z'/%3E%3C/svg%3E");cursor:pointer;display:flex;padding:8px;height:44px;width:44px}.cvg-notification-container_4sUVq{animation:cvg-animate-text_NATXX 5s}.cvg-notification-container_4sUVq[data-persistent=true]{animation:cvg-animate-text-persistent_RP4nq 5s;transform:translateY(0)}@keyframes cvg-animate-text_NATXX{0%{transform:translateY(100vh)}10%{transform:translateY(0)}80%{transform:translateY(0)}to{transform:translateY(100vh)}}@keyframes cvg-animate-text-persistent_RP4nq{0%{transform:translateY(100vh)}10%{transform:translateY(0)}to{transform:translateY(0)}}.cvg-video_YX2MH{--video-align-items: center;--video-justify-content: center;--video-max-width: 100% }.cvg-video_YX2MH{display:flex;align-items:var(--video-align-items);justify-content:var(--video-justify-content)}.cvg-video_YX2MH>video{max-width:var(--video-max-width)}`)),document.head.appendChild(t)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import * as It from "react";
import rr, { createContext as nr, useContext as $e, useRef as we, useState as ye, useEffect as be, forwardRef as pn, createElement as At, Component as hn, useLayoutEffect as vn, Fragment as Z } from "react";
import pt from "react-dom";
function or(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var it = { exports: {} }, Ce = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nt;
function yn() {
  if (Nt)
    return Ce;
  Nt = 1;
  var e = rr, r = Symbol.for("react.element"), i = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(u, p, _) {
    var b, h = {}, y = null, T = null;
    _ !== void 0 && (y = "" + _), p.key !== void 0 && (y = "" + p.key), p.ref !== void 0 && (T = p.ref);
    for (b in p)
      n.call(p, b) && !c.hasOwnProperty(b) && (h[b] = p[b]);
    if (u && u.defaultProps)
      for (b in p = u.defaultProps, p)
        h[b] === void 0 && (h[b] = p[b]);
    return { $$typeof: r, type: u, key: y, ref: T, props: h, _owner: a.current };
  }
  return Ce.Fragment = i, Ce.jsx = d, Ce.jsxs = d, Ce;
}
var Se = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kt;
function gn() {
  return kt || (kt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = rr, r = Symbol.for("react.element"), i = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), u = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), j = Symbol.iterator, E = "@@iterator";
    function P(t) {
      if (t === null || typeof t != "object")
        return null;
      var l = j && t[j] || t[E];
      return typeof l == "function" ? l : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(t) {
      {
        for (var l = arguments.length, v = new Array(l > 1 ? l - 1 : 0), O = 1; O < l; O++)
          v[O - 1] = arguments[O];
        V("error", t, v);
      }
    }
    function V(t, l, v) {
      {
        var O = F.ReactDebugCurrentFrame, Y = O.getStackAddendum();
        Y !== "" && (l += "%s", v = v.concat([Y]));
        var G = v.map(function(q) {
          return String(q);
        });
        G.unshift("Warning: " + l), Function.prototype.apply.call(console[t], console, G);
      }
    }
    var W = !1, g = !1, ie = !1, J = !1, ce = !1, ve;
    ve = Symbol.for("react.module.reference");
    function de(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === n || t === c || ce || t === a || t === _ || t === b || J || t === T || W || g || ie || typeof t == "object" && t !== null && (t.$$typeof === y || t.$$typeof === h || t.$$typeof === d || t.$$typeof === u || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === ve || t.getModuleId !== void 0));
    }
    function fe(t, l, v) {
      var O = t.displayName;
      if (O)
        return O;
      var Y = l.displayName || l.name || "";
      return Y !== "" ? v + "(" + Y + ")" : v;
    }
    function Re(t) {
      return t.displayName || "Context";
    }
    function ne(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case n:
          return "Fragment";
        case i:
          return "Portal";
        case c:
          return "Profiler";
        case a:
          return "StrictMode";
        case _:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            var l = t;
            return Re(l) + ".Consumer";
          case d:
            var v = t;
            return Re(v._context) + ".Provider";
          case p:
            return fe(t, t.render, "ForwardRef");
          case h:
            var O = t.displayName || null;
            return O !== null ? O : ne(t.type) || "Memo";
          case y: {
            var Y = t, G = Y._payload, q = Y._init;
            try {
              return ne(q(G));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var re = Object.assign, pe = 0, oe, le, ge, _e, f, x, I;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function C() {
      {
        if (pe === 0) {
          oe = console.log, le = console.info, ge = console.warn, _e = console.error, f = console.group, x = console.groupCollapsed, I = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        pe++;
      }
    }
    function M() {
      {
        if (pe--, pe === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: re({}, t, {
              value: oe
            }),
            info: re({}, t, {
              value: le
            }),
            warn: re({}, t, {
              value: ge
            }),
            error: re({}, t, {
              value: _e
            }),
            group: re({}, t, {
              value: f
            }),
            groupCollapsed: re({}, t, {
              value: x
            }),
            groupEnd: re({}, t, {
              value: I
            })
          });
        }
        pe < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var S = F.ReactCurrentDispatcher, $;
    function A(t, l, v) {
      {
        if ($ === void 0)
          try {
            throw Error();
          } catch (Y) {
            var O = Y.stack.trim().match(/\n( *(at )?)/);
            $ = O && O[1] || "";
          }
        return `
` + $ + t;
      }
    }
    var U = !1, N;
    {
      var ee = typeof WeakMap == "function" ? WeakMap : Map;
      N = new ee();
    }
    function m(t, l) {
      if (!t || U)
        return "";
      {
        var v = N.get(t);
        if (v !== void 0)
          return v;
      }
      var O;
      U = !0;
      var Y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var G;
      G = S.current, S.current = null, C();
      try {
        if (l) {
          var q = function() {
            throw Error();
          };
          if (Object.defineProperty(q.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(q, []);
            } catch (he) {
              O = he;
            }
            Reflect.construct(t, [], q);
          } else {
            try {
              q.call();
            } catch (he) {
              O = he;
            }
            t.call(q.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (he) {
            O = he;
          }
          t();
        }
      } catch (he) {
        if (he && O && typeof he.stack == "string") {
          for (var k = he.stack.split(`
`), te = O.stack.split(`
`), H = k.length - 1, K = te.length - 1; H >= 1 && K >= 0 && k[H] !== te[K]; )
            K--;
          for (; H >= 1 && K >= 0; H--, K--)
            if (k[H] !== te[K]) {
              if (H !== 1 || K !== 1)
                do
                  if (H--, K--, K < 0 || k[H] !== te[K]) {
                    var se = `
` + k[H].replace(" at new ", " at ");
                    return t.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", t.displayName)), typeof t == "function" && N.set(t, se), se;
                  }
                while (H >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        U = !1, S.current = G, M(), Error.prepareStackTrace = Y;
      }
      var Ee = t ? t.displayName || t.name : "", Dt = Ee ? A(Ee) : "";
      return typeof t == "function" && N.set(t, Dt), Dt;
    }
    function ae(t, l, v) {
      return m(t, !1);
    }
    function je(t) {
      var l = t.prototype;
      return !!(l && l.isReactComponent);
    }
    function me(t, l, v) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return m(t, je(t));
      if (typeof t == "string")
        return A(t);
      switch (t) {
        case _:
          return A("Suspense");
        case b:
          return A("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return ae(t.render);
          case h:
            return me(t.type, l, v);
          case y: {
            var O = t, Y = O._payload, G = O._init;
            try {
              return me(G(Y), l, v);
            } catch {
            }
          }
        }
      return "";
    }
    var Ae = Object.prototype.hasOwnProperty, xt = {}, Rt = F.ReactDebugCurrentFrame;
    function Ne(t) {
      if (t) {
        var l = t._owner, v = me(t.type, t._source, l ? l.type : null);
        Rt.setExtraStackFrame(v);
      } else
        Rt.setExtraStackFrame(null);
    }
    function Vr(t, l, v, O, Y) {
      {
        var G = Function.call.bind(Ae);
        for (var q in t)
          if (G(t, q)) {
            var k = void 0;
            try {
              if (typeof t[q] != "function") {
                var te = Error((O || "React class") + ": " + v + " type `" + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[q] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              k = t[q](l, q, O, v, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              k = H;
            }
            k && !(k instanceof Error) && (Ne(Y), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", O || "React class", v, q, typeof k), Ne(null)), k instanceof Error && !(k.message in xt) && (xt[k.message] = !0, Ne(Y), w("Failed %s type: %s", v, k.message), Ne(null));
          }
      }
    }
    var Gr = Array.isArray;
    function Ge(t) {
      return Gr(t);
    }
    function Hr(t) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, v = l && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return v;
      }
    }
    function Kr(t) {
      try {
        return _t(t), !1;
      } catch {
        return !0;
      }
    }
    function _t(t) {
      return "" + t;
    }
    function jt(t) {
      if (Kr(t))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Hr(t)), _t(t);
    }
    var Oe = F.ReactCurrentOwner, Jr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Tt, Et, He;
    He = {};
    function Xr(t) {
      if (Ae.call(t, "ref")) {
        var l = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Zr(t) {
      if (Ae.call(t, "key")) {
        var l = Object.getOwnPropertyDescriptor(t, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Qr(t, l) {
      if (typeof t.ref == "string" && Oe.current && l && Oe.current.stateNode !== l) {
        var v = ne(Oe.current.type);
        He[v] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ne(Oe.current.type), t.ref), He[v] = !0);
      }
    }
    function en(t, l) {
      {
        var v = function() {
          Tt || (Tt = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        v.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: v,
          configurable: !0
        });
      }
    }
    function tn(t, l) {
      {
        var v = function() {
          Et || (Et = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        v.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: v,
          configurable: !0
        });
      }
    }
    var rn = function(t, l, v, O, Y, G, q) {
      var k = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: l,
        ref: v,
        props: q,
        // Record the component responsible for creating this element.
        _owner: G
      };
      return k._store = {}, Object.defineProperty(k._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(k, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: O
      }), Object.defineProperty(k, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.freeze && (Object.freeze(k.props), Object.freeze(k)), k;
    };
    function nn(t, l, v, O, Y) {
      {
        var G, q = {}, k = null, te = null;
        v !== void 0 && (jt(v), k = "" + v), Zr(l) && (jt(l.key), k = "" + l.key), Xr(l) && (te = l.ref, Qr(l, Y));
        for (G in l)
          Ae.call(l, G) && !Jr.hasOwnProperty(G) && (q[G] = l[G]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (G in H)
            q[G] === void 0 && (q[G] = H[G]);
        }
        if (k || te) {
          var K = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          k && en(q, K), te && tn(q, K);
        }
        return rn(t, k, te, Y, O, Oe.current, q);
      }
    }
    var Ke = F.ReactCurrentOwner, wt = F.ReactDebugCurrentFrame;
    function Te(t) {
      if (t) {
        var l = t._owner, v = me(t.type, t._source, l ? l.type : null);
        wt.setExtraStackFrame(v);
      } else
        wt.setExtraStackFrame(null);
    }
    var Je;
    Je = !1;
    function Xe(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Ot() {
      {
        if (Ke.current) {
          var t = ne(Ke.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function on(t) {
      {
        if (t !== void 0) {
          var l = t.fileName.replace(/^.*[\\\/]/, ""), v = t.lineNumber;
          return `

Check your code at ` + l + ":" + v + ".";
        }
        return "";
      }
    }
    var Ct = {};
    function an(t) {
      {
        var l = Ot();
        if (!l) {
          var v = typeof t == "string" ? t : t.displayName || t.name;
          v && (l = `

Check the top-level render call using <` + v + ">.");
        }
        return l;
      }
    }
    function St(t, l) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var v = an(l);
        if (Ct[v])
          return;
        Ct[v] = !0;
        var O = "";
        t && t._owner && t._owner !== Ke.current && (O = " It was passed a child from " + ne(t._owner.type) + "."), Te(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', v, O), Te(null);
      }
    }
    function Pt(t, l) {
      {
        if (typeof t != "object")
          return;
        if (Ge(t))
          for (var v = 0; v < t.length; v++) {
            var O = t[v];
            Xe(O) && St(O, l);
          }
        else if (Xe(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var Y = P(t);
          if (typeof Y == "function" && Y !== t.entries)
            for (var G = Y.call(t), q; !(q = G.next()).done; )
              Xe(q.value) && St(q.value, l);
        }
      }
    }
    function sn(t) {
      {
        var l = t.type;
        if (l == null || typeof l == "string")
          return;
        var v;
        if (typeof l == "function")
          v = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === h))
          v = l.propTypes;
        else
          return;
        if (v) {
          var O = ne(l);
          Vr(v, t.props, "prop", O, t);
        } else if (l.PropTypes !== void 0 && !Je) {
          Je = !0;
          var Y = ne(l);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Y || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function cn(t) {
      {
        for (var l = Object.keys(t.props), v = 0; v < l.length; v++) {
          var O = l[v];
          if (O !== "children" && O !== "key") {
            Te(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", O), Te(null);
            break;
          }
        }
        t.ref !== null && (Te(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Te(null));
      }
    }
    function $t(t, l, v, O, Y, G) {
      {
        var q = de(t);
        if (!q) {
          var k = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = on(Y);
          te ? k += te : k += Ot();
          var H;
          t === null ? H = "null" : Ge(t) ? H = "array" : t !== void 0 && t.$$typeof === r ? (H = "<" + (ne(t.type) || "Unknown") + " />", k = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, k);
        }
        var K = nn(t, l, v, Y, G);
        if (K == null)
          return K;
        if (q) {
          var se = l.children;
          if (se !== void 0)
            if (O)
              if (Ge(se)) {
                for (var Ee = 0; Ee < se.length; Ee++)
                  Pt(se[Ee], t);
                Object.freeze && Object.freeze(se);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Pt(se, t);
        }
        return t === n ? cn(K) : sn(K), K;
      }
    }
    function un(t, l, v) {
      return $t(t, l, v, !0);
    }
    function ln(t, l, v) {
      return $t(t, l, v, !1);
    }
    var dn = ln, fn = un;
    Se.Fragment = n, Se.jsx = dn, Se.jsxs = fn;
  }()), Se;
}
process.env.NODE_ENV === "production" ? it.exports = yn() : it.exports = gn();
var s = it.exports, at = { exports: {} }, ke = { exports: {} }, B = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lt;
function mn() {
  if (Lt)
    return B;
  Lt = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, _ = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, j = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function V(g) {
    if (typeof g == "object" && g !== null) {
      var ie = g.$$typeof;
      switch (ie) {
        case r:
          switch (g = g.type, g) {
            case p:
            case _:
            case n:
            case c:
            case a:
            case h:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case u:
                case b:
                case j:
                case T:
                case d:
                  return g;
                default:
                  return ie;
              }
          }
        case i:
          return ie;
      }
    }
  }
  function W(g) {
    return V(g) === _;
  }
  return B.AsyncMode = p, B.ConcurrentMode = _, B.ContextConsumer = u, B.ContextProvider = d, B.Element = r, B.ForwardRef = b, B.Fragment = n, B.Lazy = j, B.Memo = T, B.Portal = i, B.Profiler = c, B.StrictMode = a, B.Suspense = h, B.isAsyncMode = function(g) {
    return W(g) || V(g) === p;
  }, B.isConcurrentMode = W, B.isContextConsumer = function(g) {
    return V(g) === u;
  }, B.isContextProvider = function(g) {
    return V(g) === d;
  }, B.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === r;
  }, B.isForwardRef = function(g) {
    return V(g) === b;
  }, B.isFragment = function(g) {
    return V(g) === n;
  }, B.isLazy = function(g) {
    return V(g) === j;
  }, B.isMemo = function(g) {
    return V(g) === T;
  }, B.isPortal = function(g) {
    return V(g) === i;
  }, B.isProfiler = function(g) {
    return V(g) === c;
  }, B.isStrictMode = function(g) {
    return V(g) === a;
  }, B.isSuspense = function(g) {
    return V(g) === h;
  }, B.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === _ || g === c || g === a || g === h || g === y || typeof g == "object" && g !== null && (g.$$typeof === j || g.$$typeof === T || g.$$typeof === d || g.$$typeof === u || g.$$typeof === b || g.$$typeof === P || g.$$typeof === F || g.$$typeof === w || g.$$typeof === E);
  }, B.typeOf = V, B;
}
var z = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mt;
function bn() {
  return Mt || (Mt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, _ = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, j = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function V(m) {
      return typeof m == "string" || typeof m == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      m === n || m === _ || m === c || m === a || m === h || m === y || typeof m == "object" && m !== null && (m.$$typeof === j || m.$$typeof === T || m.$$typeof === d || m.$$typeof === u || m.$$typeof === b || m.$$typeof === P || m.$$typeof === F || m.$$typeof === w || m.$$typeof === E);
    }
    function W(m) {
      if (typeof m == "object" && m !== null) {
        var ae = m.$$typeof;
        switch (ae) {
          case r:
            var je = m.type;
            switch (je) {
              case p:
              case _:
              case n:
              case c:
              case a:
              case h:
                return je;
              default:
                var me = je && je.$$typeof;
                switch (me) {
                  case u:
                  case b:
                  case j:
                  case T:
                  case d:
                    return me;
                  default:
                    return ae;
                }
            }
          case i:
            return ae;
        }
      }
    }
    var g = p, ie = _, J = u, ce = d, ve = r, de = b, fe = n, Re = j, ne = T, re = i, pe = c, oe = a, le = h, ge = !1;
    function _e(m) {
      return ge || (ge = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), f(m) || W(m) === p;
    }
    function f(m) {
      return W(m) === _;
    }
    function x(m) {
      return W(m) === u;
    }
    function I(m) {
      return W(m) === d;
    }
    function D(m) {
      return typeof m == "object" && m !== null && m.$$typeof === r;
    }
    function C(m) {
      return W(m) === b;
    }
    function M(m) {
      return W(m) === n;
    }
    function S(m) {
      return W(m) === j;
    }
    function $(m) {
      return W(m) === T;
    }
    function A(m) {
      return W(m) === i;
    }
    function U(m) {
      return W(m) === c;
    }
    function N(m) {
      return W(m) === a;
    }
    function ee(m) {
      return W(m) === h;
    }
    z.AsyncMode = g, z.ConcurrentMode = ie, z.ContextConsumer = J, z.ContextProvider = ce, z.Element = ve, z.ForwardRef = de, z.Fragment = fe, z.Lazy = Re, z.Memo = ne, z.Portal = re, z.Profiler = pe, z.StrictMode = oe, z.Suspense = le, z.isAsyncMode = _e, z.isConcurrentMode = f, z.isContextConsumer = x, z.isContextProvider = I, z.isElement = D, z.isForwardRef = C, z.isFragment = M, z.isLazy = S, z.isMemo = $, z.isPortal = A, z.isProfiler = U, z.isStrictMode = N, z.isSuspense = ee, z.isValidElementType = V, z.typeOf = W;
  }()), z;
}
var qt;
function ht() {
  return qt || (qt = 1, process.env.NODE_ENV === "production" ? ke.exports = mn() : ke.exports = bn()), ke.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ze, Ft;
function xn() {
  if (Ft)
    return Ze;
  Ft = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function n(c) {
    if (c == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(c);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var c = new String("abc");
      if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
        return !1;
      for (var d = {}, u = 0; u < 10; u++)
        d["_" + String.fromCharCode(u)] = u;
      var p = Object.getOwnPropertyNames(d).map(function(b) {
        return d[b];
      });
      if (p.join("") !== "0123456789")
        return !1;
      var _ = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(b) {
        _[b] = b;
      }), Object.keys(Object.assign({}, _)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ze = a() ? Object.assign : function(c, d) {
    for (var u, p = n(c), _, b = 1; b < arguments.length; b++) {
      u = Object(arguments[b]);
      for (var h in u)
        r.call(u, h) && (p[h] = u[h]);
      if (e) {
        _ = e(u);
        for (var y = 0; y < _.length; y++)
          i.call(u, _[y]) && (p[_[y]] = u[_[y]]);
      }
    }
    return p;
  }, Ze;
}
var Qe, Ut;
function vt() {
  if (Ut)
    return Qe;
  Ut = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Qe = e, Qe;
}
var et, Wt;
function ir() {
  return Wt || (Wt = 1, et = Function.call.bind(Object.prototype.hasOwnProperty)), et;
}
var tt, Yt;
function Rn() {
  if (Yt)
    return tt;
  Yt = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = vt(), i = {}, n = ir();
    e = function(c) {
      var d = "Warning: " + c;
      typeof console < "u" && console.error(d);
      try {
        throw new Error(d);
      } catch {
      }
    };
  }
  function a(c, d, u, p, _) {
    if (process.env.NODE_ENV !== "production") {
      for (var b in c)
        if (n(c, b)) {
          var h;
          try {
            if (typeof c[b] != "function") {
              var y = Error(
                (p || "React class") + ": " + u + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw y.name = "Invariant Violation", y;
            }
            h = c[b](d, b, p, u, null, r);
          } catch (j) {
            h = j;
          }
          if (h && !(h instanceof Error) && e(
            (p || "React class") + ": type specification of " + u + " `" + b + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in i)) {
            i[h.message] = !0;
            var T = _ ? _() : "";
            e(
              "Failed " + u + " type: " + h.message + (T ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, tt = a, tt;
}
var rt, Bt;
function _n() {
  if (Bt)
    return rt;
  Bt = 1;
  var e = ht(), r = xn(), i = vt(), n = ir(), a = Rn(), c = function() {
  };
  process.env.NODE_ENV !== "production" && (c = function(u) {
    var p = "Warning: " + u;
    typeof console < "u" && console.error(p);
    try {
      throw new Error(p);
    } catch {
    }
  });
  function d() {
    return null;
  }
  return rt = function(u, p) {
    var _ = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
    function h(f) {
      var x = f && (_ && f[_] || f[b]);
      if (typeof x == "function")
        return x;
    }
    var y = "<<anonymous>>", T = {
      array: F("array"),
      bigint: F("bigint"),
      bool: F("boolean"),
      func: F("function"),
      number: F("number"),
      object: F("object"),
      string: F("string"),
      symbol: F("symbol"),
      any: w(),
      arrayOf: V,
      element: W(),
      elementType: g(),
      instanceOf: ie,
      node: de(),
      objectOf: ce,
      oneOf: J,
      oneOfType: ve,
      shape: Re,
      exact: ne
    };
    function j(f, x) {
      return f === x ? f !== 0 || 1 / f === 1 / x : f !== f && x !== x;
    }
    function E(f, x) {
      this.message = f, this.data = x && typeof x == "object" ? x : {}, this.stack = "";
    }
    E.prototype = Error.prototype;
    function P(f) {
      if (process.env.NODE_ENV !== "production")
        var x = {}, I = 0;
      function D(M, S, $, A, U, N, ee) {
        if (A = A || y, N = N || $, ee !== i) {
          if (p) {
            var m = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw m.name = "Invariant Violation", m;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ae = A + ":" + $;
            !x[ae] && // Avoid spamming the console because they are often not actionable except for lib authors
            I < 3 && (c(
              "You are manually calling a React.PropTypes validation function for the `" + N + "` prop on `" + A + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), x[ae] = !0, I++);
          }
        }
        return S[$] == null ? M ? S[$] === null ? new E("The " + U + " `" + N + "` is marked as required " + ("in `" + A + "`, but its value is `null`.")) : new E("The " + U + " `" + N + "` is marked as required in " + ("`" + A + "`, but its value is `undefined`.")) : null : f(S, $, A, U, N);
      }
      var C = D.bind(null, !1);
      return C.isRequired = D.bind(null, !0), C;
    }
    function F(f) {
      function x(I, D, C, M, S, $) {
        var A = I[D], U = oe(A);
        if (U !== f) {
          var N = le(A);
          return new E(
            "Invalid " + M + " `" + S + "` of type " + ("`" + N + "` supplied to `" + C + "`, expected ") + ("`" + f + "`."),
            { expectedType: f }
          );
        }
        return null;
      }
      return P(x);
    }
    function w() {
      return P(d);
    }
    function V(f) {
      function x(I, D, C, M, S) {
        if (typeof f != "function")
          return new E("Property `" + S + "` of component `" + C + "` has invalid PropType notation inside arrayOf.");
        var $ = I[D];
        if (!Array.isArray($)) {
          var A = oe($);
          return new E("Invalid " + M + " `" + S + "` of type " + ("`" + A + "` supplied to `" + C + "`, expected an array."));
        }
        for (var U = 0; U < $.length; U++) {
          var N = f($, U, C, M, S + "[" + U + "]", i);
          if (N instanceof Error)
            return N;
        }
        return null;
      }
      return P(x);
    }
    function W() {
      function f(x, I, D, C, M) {
        var S = x[I];
        if (!u(S)) {
          var $ = oe(S);
          return new E("Invalid " + C + " `" + M + "` of type " + ("`" + $ + "` supplied to `" + D + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(f);
    }
    function g() {
      function f(x, I, D, C, M) {
        var S = x[I];
        if (!e.isValidElementType(S)) {
          var $ = oe(S);
          return new E("Invalid " + C + " `" + M + "` of type " + ("`" + $ + "` supplied to `" + D + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(f);
    }
    function ie(f) {
      function x(I, D, C, M, S) {
        if (!(I[D] instanceof f)) {
          var $ = f.name || y, A = _e(I[D]);
          return new E("Invalid " + M + " `" + S + "` of type " + ("`" + A + "` supplied to `" + C + "`, expected ") + ("instance of `" + $ + "`."));
        }
        return null;
      }
      return P(x);
    }
    function J(f) {
      if (!Array.isArray(f))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? c(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : c("Invalid argument supplied to oneOf, expected an array.")), d;
      function x(I, D, C, M, S) {
        for (var $ = I[D], A = 0; A < f.length; A++)
          if (j($, f[A]))
            return null;
        var U = JSON.stringify(f, function(ee, m) {
          var ae = le(m);
          return ae === "symbol" ? String(m) : m;
        });
        return new E("Invalid " + M + " `" + S + "` of value `" + String($) + "` " + ("supplied to `" + C + "`, expected one of " + U + "."));
      }
      return P(x);
    }
    function ce(f) {
      function x(I, D, C, M, S) {
        if (typeof f != "function")
          return new E("Property `" + S + "` of component `" + C + "` has invalid PropType notation inside objectOf.");
        var $ = I[D], A = oe($);
        if (A !== "object")
          return new E("Invalid " + M + " `" + S + "` of type " + ("`" + A + "` supplied to `" + C + "`, expected an object."));
        for (var U in $)
          if (n($, U)) {
            var N = f($, U, C, M, S + "." + U, i);
            if (N instanceof Error)
              return N;
          }
        return null;
      }
      return P(x);
    }
    function ve(f) {
      if (!Array.isArray(f))
        return process.env.NODE_ENV !== "production" && c("Invalid argument supplied to oneOfType, expected an instance of array."), d;
      for (var x = 0; x < f.length; x++) {
        var I = f[x];
        if (typeof I != "function")
          return c(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ge(I) + " at index " + x + "."
          ), d;
      }
      function D(C, M, S, $, A) {
        for (var U = [], N = 0; N < f.length; N++) {
          var ee = f[N], m = ee(C, M, S, $, A, i);
          if (m == null)
            return null;
          m.data && n(m.data, "expectedType") && U.push(m.data.expectedType);
        }
        var ae = U.length > 0 ? ", expected one of type [" + U.join(", ") + "]" : "";
        return new E("Invalid " + $ + " `" + A + "` supplied to " + ("`" + S + "`" + ae + "."));
      }
      return P(D);
    }
    function de() {
      function f(x, I, D, C, M) {
        return re(x[I]) ? null : new E("Invalid " + C + " `" + M + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
      }
      return P(f);
    }
    function fe(f, x, I, D, C) {
      return new E(
        (f || "React class") + ": " + x + " type `" + I + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + C + "`."
      );
    }
    function Re(f) {
      function x(I, D, C, M, S) {
        var $ = I[D], A = oe($);
        if (A !== "object")
          return new E("Invalid " + M + " `" + S + "` of type `" + A + "` " + ("supplied to `" + C + "`, expected `object`."));
        for (var U in f) {
          var N = f[U];
          if (typeof N != "function")
            return fe(C, M, S, U, le(N));
          var ee = N($, U, C, M, S + "." + U, i);
          if (ee)
            return ee;
        }
        return null;
      }
      return P(x);
    }
    function ne(f) {
      function x(I, D, C, M, S) {
        var $ = I[D], A = oe($);
        if (A !== "object")
          return new E("Invalid " + M + " `" + S + "` of type `" + A + "` " + ("supplied to `" + C + "`, expected `object`."));
        var U = r({}, I[D], f);
        for (var N in U) {
          var ee = f[N];
          if (n(f, N) && typeof ee != "function")
            return fe(C, M, S, N, le(ee));
          if (!ee)
            return new E(
              "Invalid " + M + " `" + S + "` key `" + N + "` supplied to `" + C + "`.\nBad object: " + JSON.stringify(I[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(f), null, "  ")
            );
          var m = ee($, N, C, M, S + "." + N, i);
          if (m)
            return m;
        }
        return null;
      }
      return P(x);
    }
    function re(f) {
      switch (typeof f) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !f;
        case "object":
          if (Array.isArray(f))
            return f.every(re);
          if (f === null || u(f))
            return !0;
          var x = h(f);
          if (x) {
            var I = x.call(f), D;
            if (x !== f.entries) {
              for (; !(D = I.next()).done; )
                if (!re(D.value))
                  return !1;
            } else
              for (; !(D = I.next()).done; ) {
                var C = D.value;
                if (C && !re(C[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function pe(f, x) {
      return f === "symbol" ? !0 : x ? x["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && x instanceof Symbol : !1;
    }
    function oe(f) {
      var x = typeof f;
      return Array.isArray(f) ? "array" : f instanceof RegExp ? "object" : pe(x, f) ? "symbol" : x;
    }
    function le(f) {
      if (typeof f > "u" || f === null)
        return "" + f;
      var x = oe(f);
      if (x === "object") {
        if (f instanceof Date)
          return "date";
        if (f instanceof RegExp)
          return "regexp";
      }
      return x;
    }
    function ge(f) {
      var x = le(f);
      switch (x) {
        case "array":
        case "object":
          return "an " + x;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + x;
        default:
          return x;
      }
    }
    function _e(f) {
      return !f.constructor || !f.constructor.name ? y : f.constructor.name;
    }
    return T.checkPropTypes = a, T.resetWarningCache = a.resetWarningCache, T.PropTypes = T, T;
  }, rt;
}
var nt, zt;
function jn() {
  if (zt)
    return nt;
  zt = 1;
  var e = vt();
  function r() {
  }
  function i() {
  }
  return i.resetWarningCache = r, nt = function() {
    function n(d, u, p, _, b, h) {
      if (h !== e) {
        var y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw y.name = "Invariant Violation", y;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var c = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: i,
      resetWarningCache: r
    };
    return c.PropTypes = c, c;
  }, nt;
}
if (process.env.NODE_ENV !== "production") {
  var Tn = ht(), En = !0;
  at.exports = _n()(Tn.isElement, En);
} else
  at.exports = jn()();
var wn = at.exports;
const o = /* @__PURE__ */ or(wn), On = "cvg-error_NZK0e", Cn = {
  error: On
}, ar = ({ children: e, fallback: r = "", isError: i }) => {
  const n = () => typeof r == "string" ? /* @__PURE__ */ s.jsx("div", { className: Cn.error, children: r }) : r;
  return i ? /* @__PURE__ */ s.jsx(n, {}) : e;
};
ar.propTypes = {
  children: o.node.isRequired,
  fallback: o.node.isRequired,
  isError: o.bool.isRequired
};
const Sn = "cvg-loader_lPaby", Pn = {
  loader: Sn
}, $n = (e) => {
  const r = ({ begin: i, transform: n }) => /* @__PURE__ */ s.jsx("rect", { x: "47", y: "24", rx: "9.4", ry: "4.8", width: "6", height: "12", transform: n, children: /* @__PURE__ */ s.jsx(
    "animate",
    {
      attributeName: "opacity",
      values: "1;0",
      keyTimes: "0;1",
      dur: "1s",
      repeatCount: "indefinite",
      begin: i
    }
  ) });
  return /* @__PURE__ */ s.jsxs("svg", { "data-icon": "loader", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...e, children: [
    /* @__PURE__ */ s.jsx(r, { begin: "-0.916s" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.833s", transform: "rotate(30 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.750s", transform: "rotate(60 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.666s", transform: "rotate(90 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.583s", transform: "rotate(120 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.500s", transform: "rotate(150 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.416s", transform: "rotate(180 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.333s", transform: "rotate(210 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.250s", transform: "rotate(240 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.166s", transform: "rotate(270 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "-0.083s", transform: "rotate(300 50 50)" }),
    /* @__PURE__ */ s.jsx(r, { begin: "0s", transform: "rotate(330 50 50)" })
  ] });
}, sr = ({ isShowSpinner: e = !0, text: r, ...i }) => /* @__PURE__ */ s.jsxs("div", { className: Pn.loader, children: [
  e && /* @__PURE__ */ s.jsx($n, { ...i }),
  r && /* @__PURE__ */ s.jsx("i", { children: r })
] });
sr.propTypes = {
  isShowSpinner: o.bool,
  text: o.string
};
const cr = ({ children: e, fallback: r = "", isLoading: i, isShowSpinner: n = !0 }) => {
  const a = () => typeof r == "string" ? /* @__PURE__ */ s.jsx(sr, { isShowSpinner: n, text: r }) : r;
  return i ? /* @__PURE__ */ s.jsx(a, {}) : e;
};
cr.propTypes = {
  children: o.node,
  fallback: o.node,
  isLoading: o.bool.isRequired,
  isShowSpinner: o.bool
};
const Dn = ({
  children: e,
  errorFallback: r,
  loadingFallback: i,
  isError: n = !1,
  isLoading: a = !1,
  isShowSpinner: c
}) => /* @__PURE__ */ s.jsx(ar, { fallback: r, isError: n, children: /* @__PURE__ */ s.jsx(cr, { fallback: i, isLoading: a, isShowSpinner: c, children: e }) });
Dn.propTypes = {
  children: o.node,
  errorFallback: o.node.isRequired,
  loadingFallback: o.node.isRequired,
  isError: o.bool,
  isLoading: o.bool,
  isShowSpinner: o.bool
};
const We = nr(), In = ({ children: e, ...r }) => {
  const { closeDialog: i } = $e(We);
  return /* @__PURE__ */ s.jsx("button", { onClick: i, ...r, children: e });
}, An = "cvg-dialog_dwQHc", Nn = "cvg-loader_qGkDk", kn = {
  dialog: An,
  loader: Nn
}, Ln = ({ children: e, className: r = "", ...i }) => {
  const { closeDialog: n, dialogRef: a } = $e(We);
  return pt.createPortal(
    /* @__PURE__ */ s.jsx(
      "dialog",
      {
        className: `${kn.dialog} ${r}`.trim(),
        onClose: n,
        ref: a,
        ...i,
        children: e
      }
    ),
    document.body
  );
}, Mn = ({ children: e, ...r }) => {
  const { openDialog: i } = $e(We);
  return /* @__PURE__ */ s.jsx("button", { onClick: i, ...r, children: e });
}, qn = ({ children: e, ...r }) => /* @__PURE__ */ s.jsx("div", { ...r, children: e }), Ye = ({ children: e, onClose: r, onOpen: i }) => {
  const n = we(null), a = () => {
    n.current.showModal(), document.body.style.overflow = "hidden", i && i();
  }, c = () => {
    n.current.close(), document.body.style.overflow = "unset", r && r();
  };
  return /* @__PURE__ */ s.jsx(We.Provider, { value: { closeDialog: c, dialogRef: n, openDialog: a }, children: e });
};
Ye.Close = In;
Ye.Container = Ln;
Ye.Content = qn;
Ye.Open = Mn;
const yt = nr(), Fn = {
  "menu-button": "cvg-menu-button_Xuz1t"
}, Un = ({ children: e, ...r }) => {
  const { setShowMenu: i } = $e(yt);
  return /* @__PURE__ */ s.jsx(
    "button",
    {
      className: Fn["menu-button"],
      onClick: () => i((n) => !n),
      ...r,
      children: e
    }
  );
}, Wn = {
  "menu-items": "cvg-menu-items_skK-W"
}, Yn = ({ children: e, ...r }) => {
  const { align: i, showMenu: n } = $e(yt);
  return /* @__PURE__ */ s.jsx("div", { className: Wn["menu-items"], "data-align": i, "data-show": n, ...r, children: e });
}, Bn = "cvg-menu_Fl7DU", zn = {
  menu: Bn
}, Pe = ({ align: e, children: r, className: i = "" }) => {
  const [n, a] = ye(!1), c = we(), d = (u) => {
    c.current && !c.current.contains(u.target) && a(!1);
  };
  return be(() => (n && document.addEventListener("click", d), !n && document.removeEventListener("click", d), () => {
    document.removeEventListener("click", d);
  }), [n]), /* @__PURE__ */ s.jsx(yt.Provider, { value: { align: e, showMenu: n, setShowMenu: a }, children: /* @__PURE__ */ s.jsx("div", { className: `${zn.menu} ${i}`.trim(), ref: c, children: r }) });
};
Pe.Button = Un;
Pe.Items = Yn;
const Vn = Object.freeze({
  proceed: "proceed",
  warning: "warning"
}), Q = Object.freeze({
  captcha: "captcha",
  checkbox: "checkbox",
  currency: "currency",
  email: "email",
  flexTextarea: "flexTextarea",
  multiselect: "multiselect",
  number: "number",
  password: "password",
  pinCode: "pinCode",
  radio: "radio",
  search: "search",
  select: "select",
  tel: "tel",
  text: "text",
  textarea: "textarea",
  toggle: "toggle"
}), R = Object.freeze({
  default: "default",
  error: "error",
  focus: "focus",
  hover: "hover"
}), Ue = Object.freeze({
  dropdown: "dropdown",
  select: "select"
}), xe = Object.freeze({
  youtube: "youtube",
  vimeo: "vimeo",
  url: "url"
}), ur = Object.freeze({
  youtube: "https://www.youtube.com/embed/",
  vimeo: "https://player.vimeo.com/video/"
}), L = Object.freeze({
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  BACKSPACE: 8,
  DELETE: 46,
  DIGIT_0: 48,
  DIGIT_1: 49,
  DIGIT_2: 50,
  DIGIT_3: 51,
  DIGIT_4: 52,
  DIGIT_5: 53,
  DIGIT_6: 54,
  DIGIT_7: 55,
  DIGIT_8: 56,
  DIGIT_9: 57,
  ENTER: "Enter",
  ESCAPE: "Escape",
  NUMPAD_0: 96,
  NUMPAD_1: 97,
  NUMPAD_2: 98,
  NUMPAD_3: 99,
  NUMPAD_4: 100,
  NUMPAD_5: 101,
  NUMPAD_6: 102,
  NUMPAD_7: 103,
  NUMPAD_8: 104,
  NUMPAD_9: 105,
  NUMPAD_DECIMAL: 110,
  PERIOD: 190,
  TAB: 9
}), Gn = Object.freeze([
  L.DIGIT_0,
  L.DIGIT_1,
  L.DIGIT_2,
  L.DIGIT_3,
  L.DIGIT_4,
  L.DIGIT_5,
  L.DIGIT_6,
  L.DIGIT_7,
  L.DIGIT_8,
  L.DIGIT_9,
  L.NUMPAD_0,
  L.NUMPAD_1,
  L.NUMPAD_2,
  L.NUMPAD_3,
  L.NUMPAD_4,
  L.NUMPAD_5,
  L.NUMPAD_6,
  L.NUMPAD_7,
  L.NUMPAD_8,
  L.NUMPAD_9
]), Hn = Object.freeze([
  ...Gn,
  L.ARROW_DOWN,
  L.ARROW_LEFT,
  L.ARROW_RIGHT,
  L.ARROW_UP,
  L.BACKSPACE,
  L.DELETE,
  L.NUMPAD_DECIMAL,
  L.PERIOD,
  L.TAB
]);
var Kn = ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl", "isolated"];
function st() {
  return st = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var i = arguments[r];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, st.apply(this, arguments);
}
function Jn(e, r) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), a, c;
  for (c = 0; c < n.length; c++)
    a = n[c], !(r.indexOf(a) >= 0) && (i[a] = e[a]);
  return i;
}
function Le(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Xn(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, ct(e, r);
}
function ct(e, r) {
  return ct = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, ct(e, r);
}
var Be = /* @__PURE__ */ function(e) {
  Xn(r, e);
  function r() {
    var n;
    return n = e.call(this) || this, n.handleExpired = n.handleExpired.bind(Le(n)), n.handleErrored = n.handleErrored.bind(Le(n)), n.handleChange = n.handleChange.bind(Le(n)), n.handleRecaptchaRef = n.handleRecaptchaRef.bind(Le(n)), n;
  }
  var i = r.prototype;
  return i.getCaptchaFunction = function(a) {
    return this.props.grecaptcha ? this.props.grecaptcha.enterprise ? this.props.grecaptcha.enterprise[a] : this.props.grecaptcha[a] : null;
  }, i.getValue = function() {
    var a = this.getCaptchaFunction("getResponse");
    return a && this._widgetId !== void 0 ? a(this._widgetId) : null;
  }, i.getWidgetId = function() {
    return this.props.grecaptcha && this._widgetId !== void 0 ? this._widgetId : null;
  }, i.execute = function() {
    var a = this.getCaptchaFunction("execute");
    if (a && this._widgetId !== void 0)
      return a(this._widgetId);
    this._executeRequested = !0;
  }, i.executeAsync = function() {
    var a = this;
    return new Promise(function(c, d) {
      a.executionResolve = c, a.executionReject = d, a.execute();
    });
  }, i.reset = function() {
    var a = this.getCaptchaFunction("reset");
    a && this._widgetId !== void 0 && a(this._widgetId);
  }, i.forceReset = function() {
    var a = this.getCaptchaFunction("reset");
    a && a();
  }, i.handleExpired = function() {
    this.props.onExpired ? this.props.onExpired() : this.handleChange(null);
  }, i.handleErrored = function() {
    this.props.onErrored && this.props.onErrored(), this.executionReject && (this.executionReject(), delete this.executionResolve, delete this.executionReject);
  }, i.handleChange = function(a) {
    this.props.onChange && this.props.onChange(a), this.executionResolve && (this.executionResolve(a), delete this.executionReject, delete this.executionResolve);
  }, i.explicitRender = function() {
    var a = this.getCaptchaFunction("render");
    if (a && this._widgetId === void 0) {
      var c = document.createElement("div");
      this._widgetId = a(c, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge,
        isolated: this.props.isolated
      }), this.captcha.appendChild(c);
    }
    this._executeRequested && this.props.grecaptcha && this._widgetId !== void 0 && (this._executeRequested = !1, this.execute());
  }, i.componentDidMount = function() {
    this.explicitRender();
  }, i.componentDidUpdate = function() {
    this.explicitRender();
  }, i.handleRecaptchaRef = function(a) {
    this.captcha = a;
  }, i.render = function() {
    var a = this.props;
    a.sitekey, a.onChange, a.theme, a.type, a.tabindex, a.onExpired, a.onErrored, a.size, a.stoken, a.grecaptcha, a.badge, a.hl, a.isolated;
    var c = Jn(a, Kn);
    return /* @__PURE__ */ It.createElement("div", st({}, c, {
      ref: this.handleRecaptchaRef
    }));
  }, r;
}(It.Component);
Be.displayName = "ReCAPTCHA";
Be.propTypes = {
  sitekey: o.string.isRequired,
  onChange: o.func,
  grecaptcha: o.object,
  theme: o.oneOf(["dark", "light"]),
  type: o.oneOf(["image", "audio"]),
  tabindex: o.number,
  onExpired: o.func,
  onErrored: o.func,
  size: o.oneOf(["compact", "normal", "invisible"]),
  stoken: o.string,
  hl: o.string,
  badge: o.oneOf(["bottomright", "bottomleft", "inline"]),
  isolated: o.bool
};
Be.defaultProps = {
  onChange: function() {
  },
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
var gt = ht(), Zn = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Qn = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, eo = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, lr = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, mt = {};
mt[gt.ForwardRef] = eo;
mt[gt.Memo] = lr;
function Vt(e) {
  return gt.isMemo(e) ? lr : mt[e.$$typeof] || Zn;
}
var to = Object.defineProperty, ro = Object.getOwnPropertyNames, Gt = Object.getOwnPropertySymbols, no = Object.getOwnPropertyDescriptor, oo = Object.getPrototypeOf, Ht = Object.prototype;
function dr(e, r, i) {
  if (typeof r != "string") {
    if (Ht) {
      var n = oo(r);
      n && n !== Ht && dr(e, n, i);
    }
    var a = ro(r);
    Gt && (a = a.concat(Gt(r)));
    for (var c = Vt(e), d = Vt(r), u = 0; u < a.length; ++u) {
      var p = a[u];
      if (!Qn[p] && !(i && i[p]) && !(d && d[p]) && !(c && c[p])) {
        var _ = no(r, p);
        try {
          to(e, p, _);
        } catch {
        }
      }
    }
  }
  return e;
}
var io = dr;
const ao = /* @__PURE__ */ or(io);
function ut() {
  return ut = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var i = arguments[r];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, ut.apply(this, arguments);
}
function so(e, r) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), a, c;
  for (c = 0; c < n.length; c++)
    a = n[c], !(r.indexOf(a) >= 0) && (i[a] = e[a]);
  return i;
}
function co(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
}
var ue = {}, uo = 0;
function lo(e, r) {
  return r = r || {}, function(n) {
    var a = n.displayName || n.name || "Component", c = /* @__PURE__ */ function(u) {
      co(p, u);
      function p(b, h) {
        var y;
        return y = u.call(this, b, h) || this, y.state = {}, y.__scriptURL = "", y;
      }
      var _ = p.prototype;
      return _.asyncScriptLoaderGetScriptLoaderID = function() {
        return this.__scriptLoaderID || (this.__scriptLoaderID = "async-script-loader-" + uo++), this.__scriptLoaderID;
      }, _.setupScriptURL = function() {
        return this.__scriptURL = typeof e == "function" ? e() : e, this.__scriptURL;
      }, _.asyncScriptLoaderHandleLoad = function(h) {
        var y = this;
        this.setState(h, function() {
          return y.props.asyncScriptOnLoad && y.props.asyncScriptOnLoad(y.state);
        });
      }, _.asyncScriptLoaderTriggerOnScriptLoaded = function() {
        var h = ue[this.__scriptURL];
        if (!h || !h.loaded)
          throw new Error("Script is not loaded.");
        for (var y in h.observers)
          h.observers[y](h);
        delete window[r.callbackName];
      }, _.componentDidMount = function() {
        var h = this, y = this.setupScriptURL(), T = this.asyncScriptLoaderGetScriptLoaderID(), j = r, E = j.globalName, P = j.callbackName, F = j.scriptId;
        if (E && typeof window[E] < "u" && (ue[y] = {
          loaded: !0,
          observers: {}
        }), ue[y]) {
          var w = ue[y];
          if (w && (w.loaded || w.errored)) {
            this.asyncScriptLoaderHandleLoad(w);
            return;
          }
          w.observers[T] = function(J) {
            return h.asyncScriptLoaderHandleLoad(J);
          };
          return;
        }
        var V = {};
        V[T] = function(J) {
          return h.asyncScriptLoaderHandleLoad(J);
        }, ue[y] = {
          loaded: !1,
          observers: V
        };
        var W = document.createElement("script");
        W.src = y, W.async = !0;
        for (var g in r.attributes)
          W.setAttribute(g, r.attributes[g]);
        F && (W.id = F);
        var ie = function(ce) {
          if (ue[y]) {
            var ve = ue[y], de = ve.observers;
            for (var fe in de)
              ce(de[fe]) && delete de[fe];
          }
        };
        P && typeof window < "u" && (window[P] = function() {
          return h.asyncScriptLoaderTriggerOnScriptLoaded();
        }), W.onload = function() {
          var J = ue[y];
          J && (J.loaded = !0, ie(function(ce) {
            return P ? !1 : (ce(J), !0);
          }));
        }, W.onerror = function() {
          var J = ue[y];
          J && (J.errored = !0, ie(function(ce) {
            return ce(J), !0;
          }));
        }, document.body.appendChild(W);
      }, _.componentWillUnmount = function() {
        var h = this.__scriptURL;
        if (r.removeOnUnmount === !0)
          for (var y = document.getElementsByTagName("script"), T = 0; T < y.length; T += 1)
            y[T].src.indexOf(h) > -1 && y[T].parentNode && y[T].parentNode.removeChild(y[T]);
        var j = ue[h];
        j && (delete j.observers[this.asyncScriptLoaderGetScriptLoaderID()], r.removeOnUnmount === !0 && delete ue[h]);
      }, _.render = function() {
        var h = r.globalName, y = this.props;
        y.asyncScriptOnLoad;
        var T = y.forwardedRef, j = so(y, ["asyncScriptOnLoad", "forwardedRef"]);
        return h && typeof window < "u" && (j[h] = typeof window[h] < "u" ? window[h] : void 0), j.ref = T, At(n, j);
      }, p;
    }(hn), d = pn(function(u, p) {
      return At(c, ut({}, u, {
        forwardedRef: p
      }));
    });
    return d.displayName = "AsyncScriptLoader(" + a + ")", d.propTypes = {
      asyncScriptOnLoad: o.func
    }, ao(d, n);
  };
}
var lt = "onloadcallback", fo = "grecaptcha";
function dt() {
  return typeof window < "u" && window.recaptchaOptions || {};
}
function po() {
  var e = dt(), r = e.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return e.enterprise ? "https://" + r + "/recaptcha/enterprise.js?onload=" + lt + "&render=explicit" : "https://" + r + "/recaptcha/api.js?onload=" + lt + "&render=explicit";
}
const ho = lo(po, {
  callbackName: lt,
  globalName: fo,
  attributes: dt().nonce ? {
    nonce: dt().nonce
  } : {}
})(Be), fr = ({ sitekey: e, size: r = "compact", ...i }) => /* @__PURE__ */ s.jsx(ho, { size: r, sitekey: e, ...i });
fr.propTypes = {
  sitekey: o.string.isRequired,
  size: o.oneOf(["compact", "normal", "invisible"])
};
const vo = (e, r = {}) => {
  const [i, n] = ye(!window.IntersectionObserver);
  let a = null;
  return be(() => (e != null && e.current && window.IntersectionObserver && (a = new IntersectionObserver(
    (c, d) => {
      c[0].isIntersecting ? (n(!0), r.doOnce && d.unobserve(e.current)) : n(!1);
    },
    {
      root: r.root || null,
      rootMargin: r.rootMargin || "0px",
      threshold: r.threshold || 0
    }
  ), a.observe(e.current)), () => a && a.disconnect()), [e.current]), i;
}, yo = "cvg-tooltip_Ut22K", go = {
  tooltip: yo
}, pr = ({ containerRef: e, describedBy: r, tip: i }) => {
  const [n, a] = ye("right"), [c, d] = ye("150px"), u = we(), p = vo(u);
  return vn(() => {
    var E, P, F, w;
    const _ = (E = e == null ? void 0 : e.current) == null ? void 0 : E.getBoundingClientRect().left, b = (P = e == null ? void 0 : e.current) == null ? void 0 : P.getBoundingClientRect().right, h = (F = u == null ? void 0 : u.current) == null ? void 0 : F.getBoundingClientRect().left, y = (w = u == null ? void 0 : u.current) == null ? void 0 : w.getBoundingClientRect().right, T = b - y, j = h - _;
    a(T > j ? "left" : "right"), d(T > j ? T : j);
  }, [e, u, i, p]), i ? /* @__PURE__ */ s.jsxs("div", { className: go.tooltip, children: [
    /* @__PURE__ */ s.jsx("div", { "aria-describedby": `describedBy_${r}`, ref: u, tabIndex: "0", children: /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ s.jsx("path", { d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" }) }) }),
    /* @__PURE__ */ s.jsx(
      "p",
      {
        "data-align": n,
        id: `describedBy_${r}`,
        role: "tooltip",
        style: { "--width": `${Math.floor(c)}px` },
        children: i
      }
    )
  ] }) : null;
};
pr.propTypes = {
  containerRef: o.object,
  describedBy: o.string,
  tip: o.string
};
const mo = "cvg-label_4caVP", bo = {
  label: mo
}, X = ({ containerRef: e, htmlFor: r, label: i, tooltip: n }) => i ? /* @__PURE__ */ s.jsxs("div", { className: bo.label, children: [
  /* @__PURE__ */ s.jsx("label", { htmlFor: r, children: i }),
  /* @__PURE__ */ s.jsx(pr, { containerRef: e, describedBy: r, tip: n })
] }) : null;
X.propTypes = {
  containerRef: o.object,
  htmlFor: o.string.isRequired,
  label: o.string,
  tooltip: o.string
};
const xo = "cvg-checkbox_AUQXd", Ro = {
  checkbox: xo
}, hr = ({ containerRef: e, label: r, name: i, tooltip: n, ...a }) => /* @__PURE__ */ s.jsxs("div", { className: Ro.checkbox, "data-show-state": R.error, children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: n }),
  /* @__PURE__ */ s.jsx("input", { "data-show-state": R.hover, name: i, type: "checkbox", ...a })
] });
hr.propTypes = {
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string
};
const _o = "cvg-currency_laIPT", jo = {
  currency: _o
}, vr = ({
  containerRef: e,
  currencyCode: r = "USD",
  label: i,
  name: n,
  onBlur: a,
  onChange: c,
  onKeyDown: d,
  tooltip: u,
  ...p
}) => {
  const b = new Intl.NumberFormat(void 0, { style: "currency", currency: r }).formatToParts(0), h = b.find((w) => w.type === "currency").value, y = b.find((w) => w.type === "fraction"), T = y ? y.value.length : 0, j = T > 0 ? 1 / 10 ** T : 1, E = (w) => {
    const [V, W] = w.split(".");
    if (W) {
      if (W.length <= T)
        return parseFloat(w).toFixed(T);
      if (T === 0)
        return Math.trunc(w).toString();
      {
        const g = new RegExp(`^\\d+(?:\\.\\d{0,${T}})?`, "g");
        return w.match(g)[0];
      }
    } else
      return parseInt(V || 0).toFixed(T);
  }, P = (w) => {
    const V = E(w.target.value);
    w.target.value = V, c && c(w), a && a(w);
  }, F = (w) => {
    Hn.includes(w.keyCode) || w.preventDefault(), d && d(w);
  };
  return /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: n, label: i, tooltip: u }),
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: jo.currency,
        "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
        children: [
          /* @__PURE__ */ s.jsx("i", { children: h }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              min: 0,
              name: n,
              onBlur: P,
              onChange: c,
              onKeyDown: F,
              step: j,
              type: "number",
              ...p
            }
          )
        ]
      }
    )
  ] });
};
vr.propTypes = {
  containerRef: o.object,
  currencyCode: o.string,
  label: o.string,
  name: o.string.isRequired,
  onBlur: o.func,
  onChange: o.func,
  onKeyDown: o.func,
  tooltip: o.string
};
const yr = ({ containerRef: e, label: r, name: i, tooltip: n, ...a }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: n }),
  /* @__PURE__ */ s.jsx(
    "input",
    {
      autoComplete: "email",
      "data-show-state": ` ${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
      name: i,
      type: "email",
      ...a
    }
  )
] });
yr.propTypes = {
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string
};
const To = "cvg-characterCount_JM6Ud", Eo = {
  characterCount: To
}, bt = ({ length: e, maxLength: r, warnLength: i }) => {
  if (!r)
    return null;
  const n = i && e >= i;
  return /* @__PURE__ */ s.jsxs("div", { className: Eo.characterCount, "data-warn": n, children: [
    e,
    " / ",
    r
  ] });
};
bt.propTypes = {
  length: o.number,
  maxLength: o.number,
  warnLength: o.number
};
const wo = {
  "flex-textarea": "cvg-flex-textarea_oijZP"
}, gr = ({ containerRef: e, label: r, name: i, maxLength: n, tooltip: a, value: c, warnLength: d, ...u }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: a }),
  /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: wo["flex-textarea"],
      "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
      children: [
        /* @__PURE__ */ s.jsx("div", { "aria-hidden": !0, "data-size-setter": !0, children: `${c} ` }),
        /* @__PURE__ */ s.jsx("textarea", { maxLength: n, name: i, value: c, ...u }),
        /* @__PURE__ */ s.jsx(bt, { length: c.length, maxLength: n, warnLength: d })
      ]
    }
  )
] });
gr.propTypes = {
  containerRef: o.object,
  label: o.string,
  maxLength: o.number,
  name: o.string.isRequired,
  tooltip: o.string,
  value: o.string,
  warnLength: o.number
};
const Oo = "cvg-toggle_dM8Pm", Co = {
  toggle: Oo
}, So = ({
  hideUnselectedLabel: e,
  showUnselectedLabel: r,
  showAllOptions: i,
  showUnselectedOptions: n,
  toggleUnselectedOptions: a
}) => {
  if (i)
    return null;
  if (n)
    return /* @__PURE__ */ s.jsx("div", { className: Co.toggle, children: /* @__PURE__ */ s.jsxs("button", { "data-toggle": !0, onClick: a, children: [
      /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ s.jsx("path", { d: "M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" }) }),
      e
    ] }) });
  if (!n)
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        "data-show-state": `${R.default}, ${R.focus}, ${R.hover}`,
        onClick: a,
        children: r
      }
    );
}, Po = "cvg-multiSelect_MH-Ql", $o = {
  multiSelect: Po
}, Kt = ({
  displayOptions: e,
  options: r,
  onSelectOption: i,
  onToggleUnselectedOptions: n,
  selected: a,
  showAll: c,
  showUnselectedOptions: d
}) => /* @__PURE__ */ s.jsx("div", { "data-show-all": c, children: /* @__PURE__ */ s.jsxs("div", { className: $o.multiSelect, "data-show-state": `${R.error}`, children: [
  [...r.entries()].filter(([u]) => a.includes(u) || c).map(([u, p]) => /* @__PURE__ */ s.jsx(
    "button",
    {
      "data-selected": a.includes(u),
      "data-show-state": `${R.default}, ${R.focus}, ${R.hover}`,
      onClick: () => i(u),
      children: p
    },
    u
  )),
  /* @__PURE__ */ s.jsx(
    So,
    {
      showUnselectedOptions: d,
      toggleUnselectedOptions: n,
      ...e
    }
  )
] }) }), mr = ({
  containerRef: e,
  label: r,
  displayOptions: i = { showAllOptions: !0 },
  name: n,
  options: a,
  onSelect: c,
  selected: d,
  tooltip: u
}) => {
  const [p, _] = ye(!1), b = (h) => {
    let y = d.includes(h) ? d.filter((T) => h != T) : [...d, h];
    c(y);
  };
  return /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: n, label: r, tooltip: u }),
    /* @__PURE__ */ s.jsx(
      Kt,
      {
        displayOptions: i,
        onSelectOption: b,
        onToggleUnselectedOptions: () => _(!p),
        options: a,
        selected: d,
        showAll: i.showAllOptions || p,
        showUnselectedOptions: p
      }
    ),
    !i.showAllOptions && !p && /* @__PURE__ */ s.jsx(
      Kt,
      {
        displayOptions: i,
        onSelectOption: b,
        onToggleUnselectedOptions: () => _(!p),
        options: a,
        selected: d,
        showUnselectedOptions: p
      }
    )
  ] });
};
mr.propTypes = {
  containerRef: o.object,
  displayOptions: o.shape({
    showAllOptions: o.bool,
    showUnselectedLabel: o.string,
    hideUnselectedLabel: o.string
  }),
  label: o.string,
  name: o.string.isRequired,
  onSelect: o.func.isRequired,
  options: o.object.isRequired,
  selected: o.arrayOf(o.string).isRequired,
  tooltip: o.string
};
const br = ({ containerRef: e, label: r, name: i, tooltip: n, ...a }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: n }),
  /* @__PURE__ */ s.jsx(
    "input",
    {
      "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
      name: i,
      type: "number",
      ...a
    }
  )
] });
br.propTypes = {
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string
};
const Do = "cvg-password_Xaio8", Io = {
  password: Do
}, xr = ({ containerRef: e, label: r, name: i, tooltip: n, value: a, ...c }) => {
  const [d, u] = ye(!0), p = d ? "password" : "text", _ = d ? "Show Password" : "Hide Password", b = we(), h = (y) => {
    y.preventDefault(), u(!d), b.current.focus();
  };
  return be(() => {
    a && a.length > 0 && (b.current.selectionStart = a.length);
  }, [d, a]), /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: n }),
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: Io.password,
        "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
        children: [
          /* @__PURE__ */ s.jsx("input", { autoComplete: "off", name: i, ref: b, type: p, value: a, ...c }),
          /* @__PURE__ */ s.jsx("button", { type: "button", tabIndex: "-1", onMouseDown: h, "aria-label": _ })
        ]
      }
    )
  ] });
};
xr.propTypes = {
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string,
  value: o.string
};
const Ao = {
  "pin-code": "cvg-pin-code_dPUUl"
}, Me = [], Rr = ({
  containerRef: e,
  label: r,
  mode: i = "box",
  name: n,
  onChange: a,
  onFocus: c,
  tooltip: d,
  value: u,
  ...p
}) => {
  const _ = (j) => {
    let E = Number(j.target.dataset.id), P = String(j.target.value);
    if (P !== "") {
      const F = [...u];
      P.split("").map((w, V) => (Number(j.target.dataset.id) + V < u.length && (F[Number(j.target.dataset.id) + V] = w, E = E + 1 < u.length ? E + 1 : E), !1)), y(Me[E]), a(F);
    }
  }, b = (j) => {
    const E = Number(j.target.dataset.id), P = Me[E + 1], F = Me[E - 1];
    switch (j.keyCode) {
      case L.BACKSPACE:
        j.preventDefault(), T(E), y(F);
        break;
      case L.DELETE:
        j.preventDefault(), T(E);
        break;
      case L.ARROW_LEFT:
        j.preventDefault(), y(F);
        break;
      case L.ARROW_RIGHT:
        j.preventDefault(), y(P);
        break;
      case L.ARROW_UP:
      case L.ARROW_DOWN:
        j.preventDefault();
        break;
    }
  }, h = (j) => {
    j.preventDefault(), j.target.focus(), j.target.setSelectionRange(0, j.target.value.length), c && c(j);
  }, y = (j) => {
    j && j.focus();
  }, T = (j) => {
    a(u.map((E, P) => P === j ? "" : E));
  };
  return /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: n, label: r, tooltip: d }),
    /* @__PURE__ */ s.jsx("div", { className: Ao["pin-code"], children: u.map((j, E) => /* @__PURE__ */ s.jsx(
      "input",
      {
        autoComplete: "off",
        "data-id": E,
        "data-mode": i,
        "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
        "data-testid": `pin_${E}`,
        inputMode: "numeric",
        name: `pin_${E}`,
        onChange: _,
        onClick: h,
        onContextMenu: (P) => P.preventDefault(),
        onFocus: h,
        onInput: _,
        onKeyDown: b,
        onMouseUp: (P) => P.preventDefault(),
        ref: (P) => Me[E] = P,
        type: "text",
        value: j,
        ...p
      },
      `pin_${E}`
    )) })
  ] });
};
Rr.propTypes = {
  containerRef: o.object,
  label: o.string,
  mode: o.string,
  name: o.string.isRequired,
  onChange: o.func.isRequired,
  onFocus: o.func,
  tooltip: o.string,
  value: o.array.isRequired
};
const No = "cvg-radio_k1aRx", ko = {
  radio: No
}, _r = ({ containerRef: e, id: r, name: i, label: n, options: a, tooltip: c, value: d, ...u }) => /* @__PURE__ */ s.jsxs("div", { className: ko.radio, "data-show-state": R.error, children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: n, tooltip: c }),
  /* @__PURE__ */ s.jsx("ul", { children: [...a.entries()].map(([p, _]) => /* @__PURE__ */ s.jsxs("li", { children: [
    /* @__PURE__ */ s.jsx(X, { htmlFor: `${r}_${p}`, label: _ }),
    /* @__PURE__ */ s.jsx(
      "input",
      {
        checked: p === d,
        "data-show-state": R.hover,
        id: `${r}_${p}`,
        name: i,
        type: "radio",
        value: p,
        ...u
      }
    )
  ] }, `${i}_radio${p}`)) })
] });
_r.propTypes = {
  containerRef: o.object,
  id: o.string.isRequired,
  label: o.string,
  name: o.string.isRequired,
  options: o.object.isRequired,
  tooltip: o.string,
  value: o.string
};
const jr = ({ containerRef: e, label: r, name: i, tooltip: n, ...a }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: n }),
  /* @__PURE__ */ s.jsx(
    "input",
    {
      "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
      name: i,
      type: "search",
      ...a
    }
  )
] });
jr.propTypes = {
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string
};
const Lo = "cvg-select_ETuEj", Mo = {
  select: Lo
}, Tr = ({ children: e, containerRef: r, label: i, name: n, tooltip: a, ...c }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: r, htmlFor: n, label: i, tooltip: a }),
  /* @__PURE__ */ s.jsx("div", { className: Mo.select, children: /* @__PURE__ */ s.jsx(
    "select",
    {
      "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
      name: n,
      ...c,
      children: e
    }
  ) })
] });
Tr.propTypes = {
  children: o.any.isRequired,
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string
};
const Er = ({ containerRef: e, label: r, name: i, tooltip: n, ...a }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: n }),
  /* @__PURE__ */ s.jsx(
    "input",
    {
      "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
      name: i,
      type: "tel",
      ...a
    }
  )
] });
Er.propTypes = {
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string
};
const qo = "cvg-textarea_idFrv", Fo = {
  textarea: qo
}, wr = ({ containerRef: e, label: r, name: i, maxLength: n, value: a, tooltip: c, warnLength: d, ...u }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: c }),
  /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: Fo.textarea,
      "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
      children: [
        /* @__PURE__ */ s.jsx("textarea", { maxLength: n, name: i, value: a, ...u }),
        /* @__PURE__ */ s.jsx(bt, { length: a.length, maxLength: n, warnLength: d })
      ]
    }
  )
] });
wr.propTypes = {
  containerRef: o.object,
  label: o.string,
  maxLength: o.number,
  name: o.string.isRequired,
  tooltip: o.string,
  value: o.string,
  warnLength: o.number
};
const Or = ({ containerRef: e, label: r, name: i, tooltip: n, ...a }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: n }),
  /* @__PURE__ */ s.jsx(
    "input",
    {
      "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
      name: i,
      type: "text",
      ...a
    }
  )
] });
Or.propTypes = {
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string
};
const Uo = "cvg-toggle_usN0s", Wo = {
  toggle: Uo
}, Cr = ({ containerRef: e, id: r, label: i, onClick: n, tooltip: a, value: c = !1, ...d }) => /* @__PURE__ */ s.jsxs("div", { className: Wo.toggle, "data-show-state": R.hover, children: [
  /* @__PURE__ */ s.jsx("button", { "data-show-state": R.error, id: r, onClick: n, value: c, ...d, children: /* @__PURE__ */ s.jsx("span", {}) }),
  /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: r, label: i, tooltip: a })
] });
Cr.propTypes = {
  containerRef: o.object,
  id: o.string.isRequired,
  label: o.string,
  onClick: o.func.isRequired,
  tooltip: o.string,
  value: o.bool
};
const Sr = ({ containerRef: e, label: r, name: i, tooltip: n, type: a, ...c }) => {
  const d = () => {
    switch (a) {
      case Q.textarea:
        return /* @__PURE__ */ s.jsx(
          "textarea",
          {
            "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
            name: i,
            ...c
          }
        );
      default:
        return /* @__PURE__ */ s.jsx(
          "input",
          {
            "data-show-state": `${R.default}, ${R.error}, ${R.focus}, ${R.hover}`,
            name: i,
            type: a,
            ...c
          }
        );
    }
  };
  return /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx(X, { containerRef: e, htmlFor: i, label: r, tooltip: n }),
    /* @__PURE__ */ s.jsx(d, {})
  ] });
};
Sr.propTypes = {
  containerRef: o.object,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string,
  type: o.string
};
const Yo = "cvg-input_A-eRZ", Bo = "cvg-error_7JDBy", Jt = {
  input: Yo,
  error: Bo
}, Pr = ({
  className: e = "",
  isControlled: r = !0,
  error: i,
  label: n,
  name: a,
  tooltip: c,
  type: d,
  value: u = "",
  ...p
}) => {
  u == null && (u = "");
  const _ = we(), b = (() => {
    switch (d) {
      case Q.captcha:
        return fr;
      case Q.checkbox:
        return hr;
      case Q.currency:
        return vr;
      case Q.email:
        return yr;
      case Q.flexTextarea:
        return gr;
      case Q.multiselect:
        return mr;
      case Q.number:
        return br;
      case Q.password:
        return xr;
      case Q.pinCode:
        return Rr;
      case Q.radio:
        return _r;
      case Q.search:
        return jr;
      case Q.select:
        return Tr;
      case Q.tel:
        return Er;
      case Q.textarea:
        return wr;
      case Q.toggle:
        return Cr;
      default:
        return Or;
    }
  })();
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: `${Jt.input} ${e}`.trim(),
      "data-error": i,
      "data-type": d,
      ref: _,
      children: [
        r && /* @__PURE__ */ s.jsx(
          b,
          {
            "aria-label": n || p.placeholder,
            containerRef: _,
            id: a,
            label: n,
            name: a,
            tooltip: c,
            value: u,
            ...p
          }
        ),
        !r && /* @__PURE__ */ s.jsx(
          Sr,
          {
            "aria-label": n || p.placeholder,
            containerRef: _,
            id: a,
            label: n,
            name: a,
            tooltip: c,
            type: d,
            ...p
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: Jt.error, children: i })
      ]
    }
  );
};
Pr.propTypes = {
  className: o.string,
  error: o.string,
  isControlled: o.bool,
  label: o.string,
  name: o.string.isRequired,
  tooltip: o.string,
  type: o.oneOf(Object.values(Q)),
  value: o.oneOfType([o.array, o.bool, o.string])
};
const zo = {
  "drop-down": "cvg-drop-down_lDkQ2"
}, $r = ({ align: e = "right", className: r, languages: i, onChange: n }) => /* @__PURE__ */ s.jsxs(Pe, { align: e, className: `${r} ${zo["drop-down"]}`.trim(), children: [
  /* @__PURE__ */ s.jsx(Pe.Button, {}),
  /* @__PURE__ */ s.jsx(Pe.Items, { children: i.map(({ id: a, name: c }) => /* @__PURE__ */ s.jsx("button", { onClick: () => n(a), children: c }, a)) })
] });
$r.propTypes = {
  align: o.string,
  className: o.string,
  languages: o.array.isRequired,
  onChange: o.func.isRequired
};
const Dr = ({ languages: e, onChange: r, ...i }) => /* @__PURE__ */ s.jsx(Pr, { name: "language", onChange: (n) => r(n.target.value), type: "select", ...i, children: e.map(({ id: n, name: a }) => /* @__PURE__ */ s.jsx("option", { value: n, children: a }, n)) });
Dr.propTypes = {
  languages: o.array.isRequired,
  onChange: o.func.isRequired
};
const Vo = ({ type: e = Ue.select, ...r }) => {
  switch (e) {
    case Ue.dropdown:
      return /* @__PURE__ */ s.jsx($r, { ...r });
    case Ue.select:
      return /* @__PURE__ */ s.jsx(Dr, { ...r });
  }
};
Vo.propTypes = {
  type: o.oneOf(Object.values(Ue))
};
const Go = "cvg-modal_hvdh6", Ho = "cvg-fadein_z-BQq", De = {
  modal: Go,
  fadein: Ho,
  "modal-content": "cvg-modal-content_CUFZ7"
}, Ie = ({ children: e, close: r, isDisplayed: i }) => {
  const n = we(null), a = ({ key: d }) => {
    n.current && d === L.ESCAPE && r();
  }, c = () => {
    const d = document.querySelector("html"), u = document.querySelectorAll("[aria-modal='true']").length;
    d && (d.style.overflow = u > 0 ? "hidden" : ""), document.body.style.overflow = u > 0 ? "hidden" : "";
  };
  return be(() => (document.addEventListener("keydown", a), () => {
    document.removeEventListener("keydown", a);
  }), []), be(() => {
    c();
  }, [i]), be(() => () => {
    c();
  }, []), i ? pt.createPortal(
    /* @__PURE__ */ s.jsx("div", { "aria-modal": !0, "aria-hidden": !0, className: De.modal, ref: n, role: "dialog", tabIndex: -1, children: e }),
    document.body
  ) : null;
};
Ie.propTypes = {
  children: o.node.isRequired,
  close: o.func.isRequired,
  isDisplayed: o.bool.isRequired
};
const Ko = "cvg-close_atiWa", Xt = {
  "alert-modal": "cvg-alert-modal_DcbS4",
  close: Ko
}, Ir = ({ close: e, closeLabel: r, content: i, isDisplayed: n }) => /* @__PURE__ */ s.jsx(Ie, { close: e, isDisplayed: n, children: /* @__PURE__ */ s.jsx("div", { className: De["modal-content"], children: /* @__PURE__ */ s.jsxs("div", { className: Xt["alert-modal"], children: [
  /* @__PURE__ */ s.jsx("div", { children: i }),
  /* @__PURE__ */ s.jsx("div", { className: Xt.close, children: /* @__PURE__ */ s.jsx("button", { onClick: e, type: "button", children: r }) })
] }) }) });
Ir.propTypes = {
  close: o.func.isRequired,
  closeLabel: o.string.isRequired,
  content: o.any.isRequired,
  isDisplayed: o.bool.isRequired
};
const ze = () => {
  const [e, r] = ye(!1);
  return [e, () => {
    r((n) => !n);
  }];
}, Ar = ({ closeLabel: e = "Close", content: r, children: i, ...n }) => {
  const [a, c] = ze();
  return /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx("button", { "aria-label": e, onClick: c, type: "button", ...n, children: i }),
    /* @__PURE__ */ s.jsx(
      Ir,
      {
        closeLabel: e,
        close: c,
        content: r,
        isDisplayed: a
      }
    )
  ] });
};
Ar.propTypes = {
  closeLabel: o.string,
  children: o.any,
  content: o.any.isRequired
};
const Jo = "cvg-actions_X5-2p", Xo = "cvg-cancel_uZqiE", Zo = "cvg-submit_cv4F9", qe = {
  "confirm-modal": "cvg-confirm-modal_1LRpL",
  actions: Jo,
  cancel: Xo,
  submit: Zo
}, Nr = ({
  cancelLabel: e,
  close: r,
  confirmAction: i,
  confirmLabel: n,
  confirmType: a,
  content: c,
  isDisplayed: d
}) => {
  const u = () => {
    i(), r();
  };
  return /* @__PURE__ */ s.jsx(Ie, { close: r, isDisplayed: d, children: /* @__PURE__ */ s.jsx("div", { className: De["modal-content"], children: /* @__PURE__ */ s.jsxs("div", { className: qe["confirm-modal"], "data-type": a, children: [
    /* @__PURE__ */ s.jsx("p", { children: c }),
    /* @__PURE__ */ s.jsxs("div", { className: qe.actions, children: [
      /* @__PURE__ */ s.jsx("button", { type: "button", onClick: r, className: qe.cancel, children: e }),
      /* @__PURE__ */ s.jsx("button", { type: "button", onClick: u, className: qe.submit, children: n })
    ] })
  ] }) }) });
};
Nr.propTypes = {
  cancelLabel: o.string.isRequired,
  close: o.func.isRequired,
  confirmAction: o.func.isRequired,
  confirmLabel: o.string.isRequired,
  confirmType: o.string.isRequired,
  content: o.string,
  isDisplayed: o.bool.isRequired
};
const kr = ({
  cancelLabel: e = "Cancel",
  confirmAction: r,
  confirmLabel: i = "Proceed",
  confirmType: n,
  content: a,
  children: c,
  ...d
}) => {
  const [u, p] = ze();
  return /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx("button", { "aria-label": e, onClick: p, type: "button", ...d, children: c }),
    /* @__PURE__ */ s.jsx(
      Nr,
      {
        cancelLabel: e,
        confirmLabel: i,
        confirmAction: r,
        content: a,
        close: p,
        isDisplayed: u,
        confirmType: n
      }
    )
  ] });
};
kr.propTypes = {
  cancelLabel: o.string,
  confirmAction: o.func.isRequired,
  confirmLabel: o.string,
  confirmType: o.string.isRequired,
  content: o.string,
  children: o.any
};
const Qo = "cvg-content_TYS4F", ot = {
  "content-modal": "cvg-content-modal_k-CEf",
  "title-bar": "cvg-title-bar_aLm3s",
  content: Qo
}, Lr = ({ close: e, content: r, isDisplayed: i, title: n }) => /* @__PURE__ */ s.jsx(Ie, { close: e, isDisplayed: i, children: /* @__PURE__ */ s.jsx("div", { className: De["modal-content"], children: /* @__PURE__ */ s.jsxs("div", { className: ot["content-modal"], children: [
  /* @__PURE__ */ s.jsxs("div", { className: ot["title-bar"], ...n ? { "data-title": n } : {}, children: [
    /* @__PURE__ */ s.jsx("h1", { children: n }),
    /* @__PURE__ */ s.jsx("button", { onClick: e, "aria-label": "Close", type: "button" })
  ] }),
  /* @__PURE__ */ s.jsx("div", { className: ot.content, children: r })
] }) }) });
Lr.propTypes = {
  close: o.func.isRequired,
  content: o.any.isRequired,
  isDisplayed: o.bool.isRequired,
  title: o.string
};
const Mr = ({ content: e, children: r, onClose: i, onOpen: n, title: a, ...c }) => {
  const [d, u] = ze(), p = () => {
    n && n(), u();
  }, _ = () => {
    i && i(), u();
  };
  return /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx("button", { "aria-label": "Open Window", onClick: p, type: "button", ...c, children: r }),
    /* @__PURE__ */ s.jsx(Lr, { content: e, close: _, isDisplayed: d, title: a })
  ] });
};
Mr.propTypes = {
  content: o.any.isRequired,
  children: o.any,
  onClose: o.func,
  onOpen: o.func,
  title: o.string
};
const ei = {
  "photo-modal": "cvg-photo-modal_uNvSV"
}, qr = ({ close: e, isDisplayed: r, photo: i }) => /* @__PURE__ */ s.jsx(Ie, { close: e, isDisplayed: r, children: /* @__PURE__ */ s.jsx("div", { className: De["modal-content"], children: /* @__PURE__ */ s.jsxs("div", { className: ei["photo-modal"], children: [
  /* @__PURE__ */ s.jsx("button", { onClick: e, "aria-label": "Close", type: "button" }),
  /* @__PURE__ */ s.jsx("img", { src: i, alt: "Photo" })
] }) }) });
qr.propTypes = {
  close: o.func.isRequired,
  isDisplayed: o.bool.isRequired,
  photo: o.string.isRequired
};
const ti = "cvg-button_bhZ6t", ri = {
  button: ti
}, Fr = ({ photo: e, usePhotoAsBackground: r = !1, children: i, ...n }) => {
  const [a, c] = ze();
  return /* @__PURE__ */ s.jsxs(Z, { children: [
    /* @__PURE__ */ s.jsx(
      "button",
      {
        "aria-label": "View Photo",
        className: ri.button,
        "data-photo-bg": r,
        onClick: c,
        style: r ? { "--photo-url": `url(${e})` } : {},
        type: "button",
        ...n,
        children: i
      }
    ),
    /* @__PURE__ */ s.jsx(qr, { photo: e, isDisplayed: a, close: c })
  ] });
};
Fr.propTypes = {
  photo: o.string.isRequired,
  usePhotoAsBackground: o.bool,
  children: o.any
};
var ft, Fe = pt;
if (process.env.NODE_ENV === "production")
  ft = Fe.createRoot, Fe.hydrateRoot;
else {
  var Zt = Fe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  ft = function(e, r) {
    Zt.usingClientEntryPoint = !0;
    try {
      return Fe.createRoot(e, r);
    } finally {
      Zt.usingClientEntryPoint = !1;
    }
  };
}
const ni = "cvg-notification_rCsSL", Qt = {
  notification: ni,
  "notification-container": "cvg-notification-container_4sUVq",
  "animate-text": "cvg-animate-text_NATXX",
  "animate-text-persistent": "cvg-animate-text-persistent_RP4nq"
}, Ur = ({ text: e, timestamp: r, type: i, options: n = {} }) => {
  const [a, c] = ye(null), d = () => {
    c(null), typeof n.callback == "function" && n.callback();
  };
  return be(() => {
    e && c({ text: e, type: i });
  }, [e, r, i]), a ? /* @__PURE__ */ s.jsx(
    "div",
    {
      className: Qt["notification-container"],
      "data-persistent": n.isPersistent,
      onAnimationEnd: n.isPersistent ? void 0 : d,
      children: /* @__PURE__ */ s.jsxs("div", { className: Qt.notification, "data-type": a.type, children: [
        /* @__PURE__ */ s.jsx("span", { children: a.text }),
        /* @__PURE__ */ s.jsx("button", { "aria-label": "Close", onClick: d })
      ] })
    }
  ) : null;
};
Ur.propTypes = {
  text: o.string.isRequired,
  timestamp: o.number.isRequired,
  type: o.string.isRequired,
  options: o.object
};
const er = document.getElementById("notification"), tr = er ? ft(er) : void 0, ci = (e, r) => Ve(r, e, "error"), ui = (e, r) => Ve(r, e, "info"), li = (e, r) => Ve(r, e, "success"), di = (e, r) => Ve(r, e, "warning"), Ve = (e, r, i) => {
  tr && tr.render(
    /* @__PURE__ */ s.jsx(Ur, { text: r, timestamp: Date.now(), type: i, options: e })
  );
}, Wr = ({ videoRef: e, videoUrl: r, ...i }) => /* @__PURE__ */ s.jsx("video", { controls: !0, ref: e, src: r, ...i });
Wr.propTypes = {
  videoRef: o.object,
  videoUrl: o.string.isRequired
};
const Yr = ({ videoId: e, videoOptions: r }) => /* @__PURE__ */ s.jsxs(Z, { children: [
  /* @__PURE__ */ s.jsx("script", { src: "https://player.vimeo.com/api/player.js" }),
  /* @__PURE__ */ s.jsx(
    "iframe",
    {
      src: `${ur.vimeo}${e}${r || "?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"}`,
      frameBorder: "0",
      allow: "autoplay; fullscreen; picture-in-picture",
      allowFullScreen: !0,
      title: "Vimeo Video Player"
    }
  )
] });
Yr.propTypes = {
  videoId: o.string.isRequired,
  videoOptions: o.string
};
const Br = ({ videoId: e }) => /* @__PURE__ */ s.jsx(
  "iframe",
  {
    src: `${ur.youtube}${e}`,
    frameBorder: "0",
    allow: "autoplay; fullscreen; picture-in-picture",
    allowFullScreen: !0,
    title: "YouTube Video Player"
  }
);
Br.propTypes = {
  videoId: o.string.isRequired
};
const oi = "cvg-video_YX2MH", ii = {
  video: oi
}, zr = ({ className: e = "", videoId: r, videoOptions: i, videoType: n, videoUrl: a, ...c }) => /* @__PURE__ */ s.jsxs("div", { className: `${ii.video} ${e}`.trim(), children: [
  n === xe.url && /* @__PURE__ */ s.jsx(Wr, { videoUrl: a, ...c }),
  n === xe.vimeo && /* @__PURE__ */ s.jsx(Yr, { videoId: r, videoOptions: i }),
  n === xe.youtube && /* @__PURE__ */ s.jsx(Br, { videoId: r })
] });
zr.propTypes = {
  className: o.string,
  videoId: o.string,
  videoOptions: o.string,
  videoType: o.oneOf([xe.vimeo, xe.youtube, xe.url]).isRequired,
  videoUrl: o.string
};
const fi = {
  AlertModalButton: Ar,
  ConfirmModalButton: kr,
  ContentModalButton: Mr,
  PhotoModalButton: Fr,
  CONFIRMATION_MODAL_TYPES: Vn
}, pi = {
  VideoPlayer: zr,
  VIDEO_PROVIDER: xe
};
export {
  Dn as AsyncContent,
  Ye as Dialog,
  Pe as DropDownMenu,
  ar as ErrorFallback,
  Pr as Input,
  Vo as LanguageSelector,
  sr as Loader,
  cr as LoadingFallback,
  fi as ModalButtons,
  pi as VideoComponents,
  ci as showError,
  ui as showInfo,
  li as showSuccess,
  di as showWarning
};
